// import React, { useState, useEffect } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { motion } from "framer-motion";
// import { useAuth } from "../components/auth/AuthContext";
// import {
//   Container,
//   Typography,
//   Box,
//   CircularProgress,
//   Button,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   Chip,
//   Accordion,
//   AccordionSummary,
//   AccordionDetails,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   Checkbox,
//   FormControlLabel,
// } from "@mui/material";
// import { ExpandMore, Settings } from "@mui/icons-material";
// import axios from "axios";
// import { Pie, Bar } from "react-chartjs-2";
// import {
//   Chart as ChartJS,
//   ArcElement,
//   Tooltip,
//   Legend,
//   BarElement,
//   CategoryScale,
//   LinearScale,
// } from "chart.js";
// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";
// import htmlDocx from "html-docx-js/dist/html-docx";
// import ExamSelectionModal from "../pages/ExamSelectionModal";

// // Register Chart.js components
// ChartJS.register(
//   ArcElement,
//   Tooltip,
//   Legend,
//   BarElement,
//   CategoryScale,
//   LinearScale
// );

// // Helper functions (KEEP ALL YOUR EXISTING HELPER FUNCTIONS HERE)
// const getShortSubjectName = (subject) => {
//   const shortNames = {
//     Language: "Lang",
//     Mathematics: "Math",
//     "Psychomotor and Creative Arts": "PCA",
//     Environmental: "Env",
//     "Religious Education": "RE",
//     "English Language": "Eng",
//     "English Composition": "Comp",
//     "Kiswahili Lugha": "Kisw",
//     "Kiswahili Insha": "Insha",
//     "Science and Technology": "Sci/Tech",
//     "Science & Technology": "Sci/Tech",
//     "Agriculture and Nutrition": "Agri/Nut",
//     Agriculture: "Agri",
//     "Social Studies": "SS",
//     "Creative Arts & Sports": "CAS",
//     "Creative Arts": "Arts",
//     Science: "Sci",
//     "Pre-Technical Studies": "PTS",
//     "Pre-Technical": "Pre-Tech",
//     "Number Work": "N/W",
//     "Social Studies and Religious Education": "SS/RE",
//     "Science and Environment": "Sci/Env",
//     "Environmental Activities": "ARM",
//     Kiswahili: "Kiswa",
//     "Language/Total": "Lang/Total",
//   };
//   return shortNames[subject] || subject;
// };

// const getExamDisplayTitle = (examType, examName) => {
//   if (examName && examName.trim() !== "" && examName !== "Unnamed") {
//     return `${examType}: ${examName}`;
//   }
//   return examType;
// };

// const mapSubjectsToDisplay = (subjects, className) => {
//   const displayOrder = {
//     PG: [
//       "Number Work",
//       "Language/Total",
//       "Reading/Jumla",
//       "Creative",
//       "Science and Environment",
//       "Social Studies and Religious Education",
//     ],
//     "Grade PP1": [
//       "Number Work",
//       "Language/Total",
//       "Kiswahili/Jumla",
//       "Creative",
//       "Science and Environment",
//       "Social Studies and Religious Education",
//     ],
//     "Grade PP2": [
//       "Number Work",
//       "Language/Total",
//       "Kiswahili/Jumla",
//       "Creative",
//       "Science and Environment",
//       "Social Studies and Religious Education",
//     ],
//     "Grade 1": [
//       "English",
//       "Kiswahili",
//       "Mathematics",
//       "Science",
//       "Social Studies and Religious Education",
//       "Environmental Activities",
//     ],
//     "Grade 2": [
//       "English",
//       "Kiswahili",
//       "Mathematics",
//       "Science",
//       "Social Studies and Religious Education",
//       "Environmental Activities",
//     ],
//     "Grade 3": [
//       "English",
//       "Kiswahili",
//       "Mathematics",
//       "Science",
//       "Social Studies and Religious Education",
//       "Environmental Activities",
//     ],
//     "Grade 4": [
//       "English Language",
//       "English Composition",
//       "Kiswahili Lugha",
//       "Kiswahili Insha",
//       "Mathematics",
//       "Science & Technology",
//       "Agriculture",
//       "Social Studies",
//       "Religious Education",
//       "Creative Arts",
//     ],
//     "Grade 5": [
//       "English Language",
//       "English Composition",
//       "Kiswahili Lugha",
//       "Kiswahili Insha",
//       "Mathematics",
//       "Science & Technology",
//       "Agriculture",
//       "Social Studies",
//       "Religious Education",
//       "Creative Arts",
//     ],
//     "Grade 6": [
//       "English Language",
//       "English Composition",
//       "Kiswahili Lugha",
//       "Kiswahili Insha",
//       "Mathematics",
//       "Science & Technology",
//       "Agriculture",
//       "Social Studies",
//       "Religious Education",
//       "Creative Arts",
//     ],
//     "Grade 7": [
//       "English Language",
//       "English Composition",
//       "Kiswahili Lugha",
//       "Kiswahili Insha",
//       "Mathematics",
//       "Science & Technology",
//       "Agriculture",
//       "Social Studies",
//       "Religious Education",
//       "Creative Arts",
//       "Pre-Technical",
//     ],
//     "Grade 8": [
//       "English Language",
//       "English Composition",
//       "Kiswahili Lugha",
//       "Kiswahili Insha",
//       "Mathematics",
//       "Science & Technology",
//       "Agriculture",
//       "Social Studies",
//       "Religious Education",
//       "Creative Arts",
//       "Pre-Technical",
//     ],
//     "Grade 9": [
//       "English Language",
//       "English Composition",
//       "Kiswahili Lugha",
//       "Kiswahili Insha",
//       "Mathematics",
//       "Science & Technology",
//       "Agriculture",
//       "Social Studies",
//       "Religious Education",
//       "Creative Arts",
//       "Pre-Technical",
//     ],
//   };

//   const subjectMapping = {
//     "Science and Technology": "Science & Technology",
//     "Agriculture and Nutrition": "Agriculture",
//     "Creative Arts & Sports": "Creative Arts",
//     "Pre-Technical Studies": "Pre-Technical",
//   };

//   if (displayOrder[className]) {
//     return displayOrder[className]
//       .map((displaySubject) => {
//         const dataSubject =
//           Object.keys(subjectMapping).find(
//             (key) => subjectMapping[key] === displaySubject
//           ) || displaySubject;
//         return subjects.includes(dataSubject)
//           ? { dataSubject, displaySubject }
//           : null;
//       })
//       .filter(Boolean);
//   }

//   return subjects.map((dataSubject) => ({
//     dataSubject,
//     displaySubject: subjectMapping[dataSubject] || dataSubject,
//   }));
// };

// const PerformanceAnalysis = () => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const { schoolId: contextSchoolId } = useAuth();
//   const {
//     grade,
//     term,
//     examType,
//     examName,
//     data,
//     schoolId = contextSchoolId,
//     isTermSummary = false,
//   } = location.state || {};

//   const dataSubjects = isTermSummary
//     ? Array.from(data?.subjects || [])
//     : Array.from(data?.subjects || []);
//   const subjectMap = mapSubjectsToDisplay(dataSubjects, grade);
//   const subjects = subjectMap.map((item) => item.dataSubject);
//   const displaySubjects = subjectMap.map((item) => item.displaySubject);

//   const [topN, setTopN] = useState(1);
//   const [isGenerating, setIsGenerating] = useState({
//     general: false,
//     streams: {},
//   });
//   const [schoolDetails, setSchoolDetails] = useState({
//     schoolName: "",
//     schoolCode: "",
//     county: "",
//     subcounty: "",
//     location: "",
//     village: "",
//     address: "",
//     phoneNumber: "",
//     email: "",
//     website: "",
//   });
//   const [learners, setLearners] = useState([]);
//   const [streams, setStreams] = useState([]);
//   const [isLoading, setIsLoading] = useState(true);
//   const [previousPositions, setPreviousPositions] = useState({});
//   const [includeHeader, setIncludeHeader] = useState(false);

//   // NEW STATE VARIABLES - ADD THESE
//   const [examSelectionOpen, setExamSelectionOpen] = useState(false);
//   const [selectedPreviousExams, setSelectedPreviousExams] = useState([]);
//   const [isLoadingPreviousPositions, setIsLoadingPreviousPositions] =
//     useState(false);

//   const year = 2025;

//   useEffect(() => {
//     const fetchSchoolDetails = async () => {
//       try {
//         const response = await axios.get(
//           "https://ed-9ny1.onrender.com/api/schools/profile",
//           { params: { schoolId } }
//         );
//         setSchoolDetails({
//           schoolName: response.data.schoolName || "Unknown School",
//           schoolCode: response.data.schoolCode || "Unknown Code",
//           county: response.data.county || "Unknown County",
//           subcounty: response.data.subcounty || "Unknown Subcounty",
//           location: response.data.location || "Unknown Location",
//           village: response.data.village || "Unknown Village",
//           address: response.data.address || "Unknown Address",
//           phoneNumber: response.data.phoneNumber || "Unknown Contact",
//           email: response.data.email || "Unknown Email",
//           website: response.data.website || "Not Specified",
//         });
//       } catch (error) {
//         console.error("Error fetching school details:", error);
//       }
//     };

//     const fetchLearners = async () => {
//       try {
//         const response = await axios.get(
//           "https://ed-9ny1.onrender.com/api/schools/learners",
//           { params: { schoolId } }
//         );
//         const gradeLearners = response.data.filter(
//           (learner) => learner.class === grade
//         );
//         setLearners(gradeLearners);
//         const gradeStreams = [
//           ...new Set(
//             gradeLearners.map((learner) => learner.stream).filter(Boolean)
//           ),
//         ].sort();
//         setStreams(gradeStreams);
//       } catch (error) {
//         console.error("Error fetching learners:", error);
//       }
//     };

//     fetchSchoolDetails();
//     fetchLearners().finally(() => setIsLoading(false));
//   }, [schoolId, grade]);

//   // NEW: Function to fetch positions for selected exams - ADD THIS FUNCTION
//   const fetchSelectedExamPositions = async (selectedExams) => {
//     if (!selectedExams || selectedExams.length === 0) {
//       setPreviousPositions({});
//       return;
//     }

//     try {
//       setIsLoadingPreviousPositions(true);
//       console.log("Fetching positions for selected exams:", selectedExams);

//       const response = await axios.post(
//         `https://ed-9ny1.onrender.com/api/schools/${schoolId}/performance/selected-previous-positions`,
//         {
//           class: grade,
//           selectedExams: selectedExams.map((exam) => ({
//             term: exam.term,
//             examType: exam.examType,
//             examName: exam.examName || null,
//           })),
//         }
//       );

//       console.log("Selected exam positions response:", response.data);
//       setPreviousPositions(response.data.previousPositions || {});
//     } catch (error) {
//       console.error("Error fetching selected exam positions:", error);
//       setPreviousPositions({});
//     } finally {
//       setIsLoadingPreviousPositions(false);
//     }
//   };

//   // NEW: Handle exam selection confirmation - ADD THIS FUNCTION
//   const handleExamSelectionConfirm = (selectedExams) => {
//     setSelectedPreviousExams(selectedExams);
//     fetchSelectedExamPositions(selectedExams);
//   };

//   // Get previous exam keys from selected exams - UPDATE THIS FUNCTION
//   const previousExamKeys = selectedPreviousExams.map(
//     (exam) => `${exam.term}-${exam.examType}-${exam.examName || ""}`
//   );

//   const calculatePositions = (learners) => {
//     let currentPosition = 1;
//     let previousTotal = null;
//     let samePositionCount = 0;

//     return learners.map((learner, index) => {
//       if (index === 0) {
//         previousTotal = learner.total;
//         return { ...learner, position: currentPosition };
//       }
//       if (learner.total === previousTotal) {
//         samePositionCount++;
//         return { ...learner, position: currentPosition };
//       } else {
//         currentPosition += samePositionCount + 1;
//         samePositionCount = 0;
//         previousTotal = learner.total;
//         return { ...learner, position: currentPosition };
//       }
//     });
//   };

//   const processedLearners = calculatePositions(
//     (data?.learners || [])
//       .map((learner) => {
//         const marks = subjects.reduce((acc, subject) => {
//           // For term summary, we already have averages
//           acc[subject] = learner.marks[subject] || 0;
//           return acc;
//         }, {});

//         // For term summary, use the pre-calculated total
//         const total = isTermSummary
//           ? learner.total || 0
//           : Object.values(marks).reduce((sum, mark) => sum + mark, 0);

//         // For term summary, use the pre-calculated mean
//         const mean = isTermSummary
//           ? learner.mean || 0
//           : (() => {
//               const validMarks = Object.values(marks).filter(
//                 (mark) => mark > 0
//               );
//               return validMarks.length > 0
//                 ? Number((total / validMarks.length).toFixed(2))
//                 : 0;
//             })();

//         const learnerData = learners.find((l) => l._id === learner.learnerId);
//         const stream = learnerData?.stream || learner.stream || "No Stream";
//         const learnerPreviousPositions =
//           previousPositions[learner.learnerId] || {};

//         return {
//           ...learner,
//           marks,
//           total,
//           mean,
//           stream,
//           previousPositions: learnerPreviousPositions,
//         };
//       })
//       .sort((a, b) => b.total - a.total)
//   );

//   const learnersByStream = streams.reduce((acc, stream) => {
//     acc[stream] = calculatePositions(
//       processedLearners
//         .filter((learner) => learner.stream === stream)
//         .sort((a, b) => b.total - a.total)
//     );
//     return acc;
//   }, {});
//   learnersByStream["General"] = processedLearners;

//   const streamAverages = Object.entries(learnersByStream)
//     .map(([stream, learners]) => ({
//       stream,
//       average:
//         learners.length > 0
//           ? Number(
//               (
//                 learners.reduce((sum, learner) => sum + learner.total, 0) /
//                 learners.length
//               ).toFixed(2)
//             )
//           : 0,
//       count: learners.length,
//     }))
//     .sort((a, b) => b.average - a.average);

//   const subjectAverages = subjects.map((subject, index) => {
//     const marks = processedLearners
//       .map((learner) => learner.marks[subject] || 0)
//       .filter((mark) => mark > 0);
//     const average =
//       marks.length > 0
//         ? Number(
//             (marks.reduce((sum, mark) => sum + mark, 0) / marks.length).toFixed(
//               2
//             )
//           )
//         : 0;
//     return {
//       subject: displaySubjects[index],
//       dataSubject: subject,
//       average,
//       count: marks.length,
//     };
//   });

//   const subjectAveragesByStream = streams.reduce((acc, stream) => {
//     const streamLearners = learnersByStream[stream];
//     acc[stream] = subjects.map((subject, index) => {
//       const marks = streamLearners
//         .map((learner) => learner.marks[subject] || 0)
//         .filter((mark) => mark > 0);
//       const average =
//         marks.length > 0
//           ? Number(
//               (
//                 marks.reduce((sum, mark) => sum + mark, 0) / marks.length
//               ).toFixed(2)
//             )
//           : 0;
//       return {
//         subject: displaySubjects[index],
//         dataSubject: subject,
//         average,
//         count: marks.length,
//       };
//     });
//     return acc;
//   }, {});

//   const topPerformers = processedLearners.slice(0, 5);

//   const topStudentsBySubject = subjects.reduce((acc, subject, index) => {
//     const sortedLearners = processedLearners
//       .filter((learner) => learner.marks[subject] > 0)
//       .sort((a, b) => b.marks[subject] - a.marks[subject]);
//     const topScores = [
//       ...new Set(sortedLearners.map((l) => l.marks[subject])),
//     ].slice(0, topN);
//     acc[displaySubjects[index]] = sortedLearners
//       .filter((learner) => topScores.includes(learner.marks[subject]))
//       .map((learner) => ({
//         name: learner.learnerName,
//         score: learner.marks[subject],
//         stream: learner.stream,
//         learnerId: learner.learnerId,
//       }));
//     return acc;
//   }, {});

//   const pieData = {
//     labels: subjectAverages.map((item) => getShortSubjectName(item.subject)),
//     datasets: [
//       {
//         data: subjectAverages.map((item) => item.average),
//         backgroundColor: subjectAverages.map(
//           (_, index) =>
//             `hsl(${(index * 360) / (subjects.length || 1)}, 65%, 55%)`
//         ),
//       },
//     ],
//   };

//   const barData = {
//     labels: displaySubjects.map((sub) => getShortSubjectName(sub)),
//     datasets: [
//       {
//         label: "Average (%)",
//         data: subjectAverages.map((item) => item.average || 0),
//         backgroundColor: "#3182CE",
//       },
//     ],
//   };

//   const prepareSubjectComparisonData = (displaySubject) => {
//     const subjectIndex = displaySubjects.indexOf(displaySubject);
//     const dataSubject = subjects[subjectIndex];
//     return {
//       labels: streams,
//       datasets: [
//         {
//           data: streams.map(
//             (stream) =>
//               subjectAveragesByStream[stream]?.find(
//                 (item) => item.dataSubject === dataSubject
//               )?.average || 0
//           ),
//           backgroundColor: streams.map(
//             (_, index) =>
//               `hsl(${(index * 360) / (streams.length || 1)}, 65%, 55%)`
//           ),
//         },
//       ],
//     };
//   };

//   const calculateMeanRow = (learners) => {
//     const meanData = {
//       learnerName: "Mean",
//       marks: {},
//       total: 0,
//       displayMarks: {},
//       previousPosition: "-",
//     };
//     subjects.forEach((subject, index) => {
//       const subjectMarks = learners
//         .map((learner) => learner.marks[subject] || 0)
//         .filter((mark) => mark > 0);
//       const sum = subjectMarks.reduce((a, b) => a + b, 0);
//       meanData.marks[subject] =
//         Number((sum / (subjectMarks.length || 1)).toFixed(2)) || 0;
//       meanData.displayMarks[displaySubjects[index]] = meanData.marks[subject];
//     });
//     const totals = learners.map((learner) => learner.total);
//     meanData.total =
//       Number(
//         (totals.reduce((a, b) => a + b, 0) / (learners.length || 1)).toFixed(2)
//       ) || 0;
//     return meanData;
//   };

//   const generateCSVContent = (learners, stream, type) => {
//     const sections = [
//       [`School: ${schoolDetails.schoolName}`],
//       [`Email: ${schoolDetails.email}`],
//       [`Year: ${year}`],
//       [""],
//       [`${grade} - Term ${term} - ${getExamDisplayTitle(examType, examName)}`],
//       [""],
//     ];

//     if (type === "general" && streams.length > 0) {
//       sections.push(["Subject Analysis by Stream"]);
//       sections.push([
//         "Stream",
//         ...displaySubjects.map((sub) => getShortSubjectName(sub)),
//         "Total",
//         "Average",
//       ]);
//       streams.sort().forEach((stream) => {
//         const averages = subjectAveragesByStream[stream].map(
//           (item) => item.average || 0
//         );
//         const streamTotal = averages.reduce((sum, v) => sum + v, 0);
//         const streamAvg =
//           subjects.length > 0 ? streamTotal / subjects.length : 0;
//         sections.push([
//           stream,
//           ...averages,
//           streamTotal.toFixed(2),
//           streamAvg.toFixed(2),
//         ]);
//       });
//       const overallAverages = subjectAverages.map((item) => item.average || 0);
//       const overallTotal = overallAverages.reduce((sum, v) => sum + v, 0);
//       const overallAvg =
//         subjects.length > 0 ? overallTotal / subjects.length : 0;
//       sections.push([
//         "Overall",
//         ...overallAverages.map((v) => v.toFixed(2)),
//         overallTotal.toFixed(2),
//         overallAvg.toFixed(2),
//       ]);
//       sections.push([""]);
//     }

//     sections.push(["Top Performers by Subject"]);
//     sections.push(["Student", "Subject", "Score (%)"]);
//     Object.entries(topStudentsBySubject).forEach(([subject, students]) => {
//       students.forEach((student) => {
//         sections.push([
//           `${student.name} (${student.stream || "No Stream"})`,
//           getShortSubjectName(subject),
//           student.score,
//         ]);
//       });
//     });
//     sections.push([""]);

//     sections.push([
//       type === "general"
//         ? "Detailed Results - All Students"
//         : `Detailed Results - Stream ${stream}`,
//     ]);

//     // UPDATE HEADERS TO USE SELECTED EXAMS
//     const headers = [
//       "No.",
//       "Student",
//       ...displaySubjects.map((sub) => getShortSubjectName(sub)),
//       "Total",
//       "Position",
//       ...selectedPreviousExams.map((exam, index) => `Prev ${index + 1}`),
//       ...(type === "general" ? ["Stream"] : []),
//     ];

//     const rows = learners.map((learner, index) => [
//       index + 1,
//       `${learner.learnerName}${
//         type === "general" && learner.stream ? ` (${learner.stream})` : ""
//       }`,
//       ...subjects.map((subject) => learner.marks[subject] || "-"),
//       learner.total,
//       learner.position,
//       ...previousExamKeys.map((key) => learner.previousPositions[key] ?? "-"),
//       ...(type === "general" ? [learner.stream || "No Stream"] : []),
//     ]);

//     const meanRow = calculateMeanRow(learners);
//     const meanRowData = [
//       "-",
//       "Mean",
//       ...subjects.map((subject) => `${meanRow.marks[subject]}`),
//       meanRow.total,
//       "-",
//       ...selectedPreviousExams.map(() => "-"),
//       ...(type === "general" ? ["-"] : []),
//     ];
//     sections.push(headers);
//     sections.push(...rows);
//     sections.push(meanRowData);

//     return sections.map((row) => row.join(",")).join("\n");
//   };

//   // ADD THIS NEW FUNCTION FOR EXAM SELECTION BUTTON
//   const renderExamSelectionButton = () => (
//     <Box
//       sx={{
//         display: "flex",
//         alignItems: "center",
//         gap: 2,
//         mb: 2,
//         p: 2,
//         bgcolor: "#f5f5f5",
//         borderRadius: 1,
//       }}
//     >
//       <Typography variant="h6" sx={{ flexGrow: 1 }}>
//         Previous Exam Positions
//       </Typography>

//       {selectedPreviousExams.length > 0 && (
//         <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
//           {selectedPreviousExams.map((exam, index) => (
//             <Chip
//               key={exam._id || index}
//               label={`${index + 1}. ${getExamDisplayTitle(
//                 exam.examType,
//                 exam.examName
//               )}`}
//               size="small"
//               variant="outlined"
//             />
//           ))}
//         </Box>
//       )}

//       <Button
//         variant="outlined"
//         startIcon={<Settings />}
//         onClick={() => setExamSelectionOpen(true)}
//         disabled={isLoadingPreviousPositions}
//       >
//         {isLoadingPreviousPositions ? (
//           <CircularProgress size={20} />
//         ) : selectedPreviousExams.length > 0 ? (
//           `Configure (${selectedPreviousExams.length} selected)`
//         ) : (
//           "Select Previous Exams"
//         )}
//       </Button>
//     </Box>
//   );

//   const generateDocxContent = (learners, stream, type) => {
//     const headerContent = includeHeader
//       ? `
//       <div style="font-family: Arial, sans-serif; text-align: center; margin-bottom: 20px; border-bottom: 2px solid #3182CE; padding-bottom: 10px;">
//         <h1 style="font-size: 26px; margin: 5px 0; color: #2D3748;">${
//           schoolDetails.schoolName
//         }</h1>
//         <p style="font-size: 16px; margin: 5px 0; color: #4A5568;">Email: ${
//           schoolDetails.email
//         }</p>
//         <p style="font-size: 16px; margin: 5px 0; color: #4A5568;">Year: ${year}</p>
//         <h2 style="font-size: 22px; margin: 5px 0; color: #3182CE;">${grade} - Term ${term} - ${getExamDisplayTitle(
//           examType,
//           examName
//         )} - ${type === "general" ? "General Results" : `Stream ${stream}`}</h2>
//       </div>
//     `
//       : "";

//     let content = `
//       <div style="font-family: Arial, sans-serif; padding: 30px; line-height: 1.6;">
//         ${!includeHeader ? headerContent : ""}
//     `;

//     if (type === "general" && streams.length > 0) {
//       content += `
//         <h3 style="font-size: 20px; color: #2D3748; margin-bottom: 15px; border-bottom: 1px solid #E2E8F0;">Subject Analysis by Stream</h3>
//         <table style="width: 100%; border-collapse: collapse; margin-top: 12px; border: 1px solid #E2E8F0; page-break-inside: auto;">
//           <thead>
//             <tr style="background-color: #3182CE; color: #FFFFFF;">
//               <th style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">Stream</th>
//               ${displaySubjects
//                 .map(
//                   (subject) =>
//                     `<th style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${getShortSubjectName(
//                       subject
//                     )}</th>`
//                 )
//                 .join("")}
//               <th style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">Total</th>
//               <th style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">Average</th>
//             </tr>
//           </thead>
//           <tbody>
//             ${streams
//               .sort()
//               .map((stream) => {
//                 const averages = subjectAveragesByStream[stream].map(
//                   (item) => item.average || 0
//                 );
//                 const streamTotal = averages.reduce((sum, v) => sum + v, 0);
//                 const streamAvg =
//                   subjects.length > 0 ? streamTotal / subjects.length : 0;
//                 return `
//                 <tr>
//                   <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${stream}</td>
//                   ${averages
//                     .map(
//                       (avg) =>
//                         `<td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${avg.toFixed(
//                           2
//                         )}</td>`
//                     )
//                     .join("")}
//                   <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0; font-weight: bold;">${streamTotal.toFixed(
//                     2
//                   )}</td>
//                   <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0; font-weight: bold;">${streamAvg.toFixed(
//                     2
//                   )}</td>
//                 </tr>
//               `;
//               })
//               .join("")}
//             ${(() => {
//               const overallAverages = subjectAverages.map(
//                 (item) => item.average || 0
//               );
//               const overallTotal = overallAverages.reduce(
//                 (sum, v) => sum + v,
//                 0
//               );
//               const overallAvg =
//                 subjects.length > 0 ? overallTotal / subjects.length : 0;
//               return `
//                 <tr style="background-color: #F0F9FF; font-weight: bold;">
//                   <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">Overall</td>
//                   ${overallAverages
//                     .map(
//                       (avg) =>
//                         `<td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${avg.toFixed(
//                           2
//                         )}</td>`
//                     )
//                     .join("")}
//                   <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${overallTotal.toFixed(
//                     2
//                   )}</td>
//                   <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${overallAvg.toFixed(
//                     2
//                   )}</td>
//                 </tr>
//               `;
//             })()}
//           </tbody>
//         </table>
//       `;
//     }

//     content += `
//         <h3 style="font-size: 20px; color: #2D3748; margin: 20px 0 15px; border-bottom: 1px solid #E2E8F0;">Top Performers by Subject</h3>
//         <table style="width: 100%; border-collapse: collapse; margin-top: 12px; border: 1px solid #E2E8F0; page-break-inside: auto;">
//           <thead>
//             <tr style="background-color: #3182CE; color: #FFFFFF;">
//               <th style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">Student</th>
//               <th style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">Subject</th>
//               <th style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">Score (%)</th>
//             </tr>
//           </thead>
//           <tbody>
//             ${Object.entries(topStudentsBySubject)
//               .flatMap(([subject, students]) =>
//                 students.map(
//                   (student) => `
//                 <tr>
//                   <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${
//                     student.name
//                   } (${student.stream || "No Stream"})</td>
//                   <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${getShortSubjectName(
//                     subject
//                   )}</td>
//                   <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${
//                     student.score
//                   }</td>
//                 </tr>
//               `
//                 )
//               )
//               .join("")}
//           </tbody>
//         </table>

//         <h3 style="font-size: 20px; color: #2D3748; margin: 20px 0 15px; border-bottom: 1px solid #E2E8F0;">Detailed Results</h3>
//         <table style="width: 100%; border-collapse: collapse; margin-top: 12px; border: 1px solid #E2E8F0; page-break-inside: auto;">
//           <thead>
//             <tr style="background-color: #3182CE; color: #FFFFFF;">
//               <th style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">No.</th>
//               <th style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">Student</th>
//               ${displaySubjects
//                 .map(
//                   (subject) =>
//                     `<th style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${getShortSubjectName(
//                       subject
//                     )}</th>`
//                 )
//                 .join("")}
//               <th style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">Total</th>
//               <th style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">Position</th>
//               <th style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">Prev. Positions</th>
//               ${
//                 type === "general"
//                   ? '<th style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">Stream</th>'
//                   : ""
//               }
//             </tr>
//           </thead>
//           <tbody>
//             ${learners
//               .map(
//                 (learner, index) => `
//               <tr style="page-break-inside: avoid;">
//                 <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${
//                   index + 1
//                 }</td>
//                 <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${
//                   learner.learnerName
//                 }${
//                   type === "general" && learner.stream
//                     ? ` (${learner.stream})`
//                     : ""
//                 }</td>
//                 ${subjects
//                   .map(
//                     (subject) =>
//                       `<td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${
//                         learner.marks[subject] || "-"
//                       }</td>`
//                   )
//                   .join("")}
//                 <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0; font-weight: bold;">${
//                   learner.total
//                 }</td>
//                 <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${
//                   learner.position
//                 }</td>
//                 <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${previousExamKeys
//                   .map((key) => learner.previousPositions[key] ?? "-")
//                   .join(",")}</td>
//                 ${
//                   type === "general"
//                     ? `<td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${
//                         learner.stream || "No Stream"
//                       }</td>`
//                     : ""
//                 }
//               </tr>
//             `
//               )
//               .join("")}
//             <tr style="background-color: #F0F9FF; font-weight: bold; page-break-inside: avoid;">
//               <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">-</td>
//               <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">Mean</td>
//               ${displaySubjects
//                 .map(
//                   (subject) =>
//                     `<td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${
//                       calculateMeanRow(learners).displayMarks[subject]
//                     }</td>`
//                 )
//                 .join("")}
//               <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0; font-weight: bold;">${
//                 calculateMeanRow(learners).total
//               }</td>
//               <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">-</td>
//               <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">-</td>
//               ${
//                 type === "general"
//                   ? '<td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">-</td>'
//                   : ""
//               }
//             </tr>
//           </tbody>
//         </table>
//       </div>
//     `;
//     return content;
//   };

//   const createDocument = async (stream, type, format) => {
//     try {
//       const learnersToUse =
//         type === "general"
//           ? learnersByStream["General"]
//           : learnersByStream[stream];
//       const fileNameBase = `Performance_${grade}_Term${term}_${getExamDisplayTitle(
//         examType,
//         examName
//       ).replace(/\s+/g, "_")}_${
//         type === "general" ? "General" : `Stream_${stream}`
//       }`;
//       setIsGenerating((prev) => ({
//         ...prev,
//         [type === "general" ? "general" : "streams"]: {
//           ...prev.streams,
//           [stream]: true,
//         },
//       }));

//       if (format === "pdf") {
//         const doc = new jsPDF();
//         doc.setFontSize(16);
//         doc.text(schoolDetails.schoolName, 105, 20, { align: "center" });
//         doc.setFontSize(12);
//         doc.text(`Email: ${schoolDetails.email}`, 105, 30, { align: "center" });
//         doc.text(`Year: ${year}`, 105, 40, { align: "center" });
//         doc.text(
//           `${grade} - Term ${term} - ${getExamDisplayTitle(
//             examType,
//             examName
//           )} - ${type === "general" ? "General Results" : `Stream ${stream}`}`,
//           105,
//           50,
//           { align: "center" }
//         );

//         let startY = 60;

//         if (type === "general" && streams.length > 0) {
//           doc.text("Subject Analysis by Stream", 20, startY);
//           autoTable(doc, {
//             startY: startY + 5,
//             head: [
//               [
//                 "Stream",
//                 ...displaySubjects.map((sub) => getShortSubjectName(sub)),
//                 "Total",
//                 "Average",
//               ],
//             ],
//             body: [
//               ...streams.sort().map((stream) => {
//                 const averages = subjectAveragesByStream[stream].map(
//                   (item) => item.average || 0
//                 );
//                 const streamTotal = averages.reduce((sum, v) => sum + v, 0);
//                 const streamAvg =
//                   subjects.length > 0 ? streamTotal / subjects.length : 0;
//                 return [
//                   stream,
//                   ...averages,
//                   streamTotal.toFixed(2),
//                   streamAvg.toFixed(2),
//                 ];
//               }),
//               (() => {
//                 const overallAverages = subjectAverages.map(
//                   (item) => item.average || 0
//                 );
//                 const overallTotal = overallAverages.reduce(
//                   (sum, v) => sum + v,
//                   0
//                 );
//                 const overallAvg =
//                   subjects.length > 0 ? overallTotal / subjects.length : 0;
//                 return [
//                   "Overall",
//                   ...overallAverages,
//                   overallTotal.toFixed(2),
//                   overallAvg.toFixed(2),
//                 ];
//               })(),
//             ],
//             styles: { lineColor: [226, 232, 240], lineWidth: 0.1 },
//             headStyles: {
//               fillColor: [49, 130, 206],
//               textColor: [255, 255, 255],
//             },
//             alternateRowStyles: { fillColor: [240, 249, 255] },
//           });
//           startY = doc.lastAutoTable.finalY + 10;
//         }

//         doc.text("Top Performers by Subject", 20, startY);
//         autoTable(doc, {
//           startY: startY + 5,
//           head: [["Student", "Subject", "Score (%)"]],
//           body: Object.entries(topStudentsBySubject).flatMap(
//             ([subject, students]) =>
//               students.map((student) => [
//                 `${student.name} (${student.stream || "No Stream"})`,
//                 getShortSubjectName(subject),
//                 student.score,
//               ])
//           ),
//           styles: { lineColor: [226, 232, 240], lineWidth: 0.1 },
//           headStyles: { fillColor: [49, 130, 206], textColor: [255, 255, 255] },
//           alternateRowStyles: { fillColor: [240, 249, 255] },
//         });
//         startY = doc.lastAutoTable.finalY + 10;

//         doc.text("Detailed Results", 20, startY);
//         autoTable(doc, {
//           startY: startY + 5,
//           head: [
//             [
//               "No.",
//               "Student",
//               ...displaySubjects.map((sub) => getShortSubjectName(sub)),
//               "Total",
//               "Position",
//               "Prev. Positions",
//               ...(type === "general" ? ["Stream"] : []),
//             ],
//           ],
//           body: [
//             ...learnersToUse.map((learner, index) => [
//               index + 1,
//               `${learner.learnerName}${
//                 type === "general" && learner.stream
//                   ? ` (${learner.stream})`
//                   : ""
//               }`,
//               ...subjects.map((subject) => learner.marks[subject] || "-"),
//               learner.total,
//               learner.position,
//               previousExamKeys
//                 .map((key) => learner.previousPositions[key] ?? "-")
//                 .join(","),
//               ...(type === "general" ? [learner.stream || "No Stream"] : []),
//             ]),
//             [
//               "-",
//               "Mean",
//               ...subjects.map(
//                 (subject) => calculateMeanRow(learnersToUse).marks[subject]
//               ),
//               calculateMeanRow(learnersToUse).total,
//               "-",
//               "-",
//               ...(type === "general" ? ["-"] : []),
//             ],
//           ],
//           styles: { lineColor: [226, 232, 240], lineWidth: 0.1 },
//           headStyles: { fillColor: [49, 130, 206], textColor: [255, 255, 255] },
//           alternateRowStyles: { fillColor: [240, 249, 255] },
//         });
//         doc.save(`${fileNameBase}.pdf`);
//       } else if (format === "docx") {
//         const htmlContent = generateDocxContent(learnersToUse, stream, type);
//         const docx = htmlDocx.asBlob(htmlContent);
//         const url = URL.createObjectURL(docx);
//         const a = document.createElement("a");
//         a.href = url;
//         a.download = `${fileNameBase}.docx`;
//         a.click();
//         URL.revokeObjectURL(url);
//       } else if (format === "csv") {
//         const csvContent = generateCSVContent(learnersToUse, stream, type);
//         const blob = new Blob([csvContent], {
//           type: "text/csv;charset=utf-8;",
//         });
//         const url = URL.createObjectURL(blob);
//         const a = document.createElement("a");
//         a.href = url;
//         a.download = `${fileNameBase}.csv`;
//         a.click();
//         URL.revokeObjectURL(url);
//       }
//     } catch (error) {
//       console.error(`Error generating ${format} report:`, error);
//       alert(`Failed to generate ${format} report. Please try again.`);
//     } finally {
//       setIsGenerating((prev) => ({
//         ...prev,
//         [type === "general" ? "general" : "streams"]: {
//           ...prev.streams,
//           [stream]: false,
//         },
//       }));
//     }
//   };

//   const createFullPDF = async (format) => {
//     try {
//       setIsGenerating((prev) => ({ ...prev, general: true }));
//       const fileName = `Performance_${grade}_Term${term}_${getExamDisplayTitle(
//         examType,
//         examName
//       ).replace(/\s+/g, "_")}`;
//       const generalMeanRow = calculateMeanRow(learnersByStream["General"]);
//       const streamMeanRows = streams.reduce((acc, stream) => {
//         acc[stream] = calculateMeanRow(learnersByStream[stream]);
//         return acc;
//       }, {});

//       if (format === "pdf") {
//         const doc = new jsPDF();
//         doc.setFontSize(16);
//         doc.text(schoolDetails.schoolName, 105, 20, { align: "center" });
//         doc.setFontSize(12);
//         doc.text(`Email: ${schoolDetails.email}`, 105, 30, { align: "center" });
//         doc.text(`Year: ${year}`, 105, 40, { align: "center" });
//         doc.text(
//           `${grade} - Term ${term} - ${getExamDisplayTitle(
//             examType,
//             examName
//           )}`,
//           105,
//           50,
//           { align: "center" }
//         );

//         let startY = 60;

//         if (streams.length > 0) {
//           doc.text("Subject Analysis by Stream", 20, startY);
//           autoTable(doc, {
//             startY: startY + 5,
//             head: [
//               [
//                 "Stream",
//                 ...displaySubjects.map((sub) => getShortSubjectName(sub)),
//                 "Total",
//                 "Average",
//               ],
//             ],
//             body: [
//               ...streams.sort().map((stream) => {
//                 const averages = subjectAveragesByStream[stream].map(
//                   (item) => item.average || 0
//                 );
//                 const streamTotal = averages.reduce((sum, v) => sum + v, 0);
//                 const streamAvg =
//                   subjects.length > 0 ? streamTotal / subjects.length : 0;
//                 return [
//                   stream,
//                   ...averages,
//                   streamTotal.toFixed(2),
//                   streamAvg.toFixed(2),
//                 ];
//               }),
//               (() => {
//                 const overallAverages = subjectAverages.map(
//                   (item) => item.average || 0
//                 );
//                 const overallTotal = overallAverages.reduce(
//                   (sum, v) => sum + v,
//                   0
//                 );
//                 const overallAvg =
//                   subjects.length > 0 ? overallTotal / subjects.length : 0;
//                 return [
//                   "Overall",
//                   ...overallAverages,
//                   overallTotal.toFixed(2),
//                   overallAvg.toFixed(2),
//                 ];
//               })(),
//             ],
//             styles: { lineColor: [226, 232, 240], lineWidth: 0.1 },
//             headStyles: {
//               fillColor: [49, 130, 206],
//               textColor: [255, 255, 255],
//             },
//             alternateRowStyles: { fillColor: [240, 249, 255] },
//           });
//           startY = doc.lastAutoTable.finalY + 10;
//         }

//         doc.text("Top Performers by Subject", 20, startY);
//         autoTable(doc, {
//           startY: startY + 5,
//           head: [["Student", "Subject", "Score (%)"]],
//           body: Object.entries(topStudentsBySubject).flatMap(
//             ([subject, students]) =>
//               students.map((student) => [
//                 `${student.name} (${student.stream || "No Stream"})`,
//                 getShortSubjectName(subject),
//                 student.score,
//               ])
//           ),
//           styles: { lineColor: [226, 232, 240], lineWidth: 0.1 },
//           headStyles: { fillColor: [49, 130, 206], textColor: [255, 255, 255] },
//           alternateRowStyles: { fillColor: [240, 249, 255] },
//         });
//         startY = doc.lastAutoTable.finalY + 10;

//         doc.text("Detailed Results - All Students", 20, startY);
//         autoTable(doc, {
//           startY: startY + 5,
//           head: [
//             [
//               "No.",
//               "Student",
//               ...displaySubjects.map((sub) => getShortSubjectName(sub)),
//               "Total",
//               "Position",
//               "Prev. Positions",
//               "Stream",
//             ],
//           ],
//           body: [
//             ...learnersByStream["General"].map((learner, index) => [
//               index + 1,
//               `${learner.learnerName}${
//                 learner.stream ? ` (${learner.stream})` : ""
//               }`,
//               ...subjects.map((subject) => learner.marks[subject] || "-"),
//               learner.total,
//               learner.position,
//               previousExamKeys
//                 .map((key) => learner.previousPositions[key] ?? "-")
//                 .join(","),
//               learner.stream || "No Stream",
//             ]),
//             [
//               "-",
//               "Mean",
//               ...subjects.map((subject) => generalMeanRow.marks[subject]),
//               generalMeanRow.total,
//               "-",
//               "-",
//               "-",
//             ],
//           ],
//           styles: { lineColor: [226, 232, 240], lineWidth: 0.1 },
//           headStyles: { fillColor: [49, 130, 206], textColor: [255, 255, 255] },
//           alternateRowStyles: { fillColor: [240, 249, 255] },
//         });

//         streams.sort().forEach((stream) => {
//           doc.addPage();
//           doc.text(`Detailed Results - Stream ${stream}`, 20, 20);
//           autoTable(doc, {
//             startY: 25,
//             head: [
//               [
//                 "No.",
//                 "Student",
//                 ...displaySubjects.map((sub) => getShortSubjectName(sub)),
//                 "Total",
//                 "Position",
//                 "Prev. Positions",
//               ],
//             ],
//             body: [
//               ...learnersByStream[stream].map((learner, index) => [
//                 index + 1,
//                 learner.learnerName,
//                 ...subjects.map((subject) => learner.marks[subject] || "-"),
//                 learner.total,
//                 learner.position,
//                 previousExamKeys
//                   .map((key) => learner.previousPositions[key] ?? "-")
//                   .join(","),
//               ]),
//               [
//                 "-",
//                 "Mean",
//                 ...subjects.map(
//                   (subject) => streamMeanRows[stream].marks[subject]
//                 ),
//                 streamMeanRows[stream].total,
//                 "-",
//                 "-",
//               ],
//             ],
//             styles: { lineColor: [226, 232, 240], lineWidth: 0.1 },
//             headStyles: {
//               fillColor: [49, 130, 206],
//               textColor: [255, 255, 255],
//             },
//             alternateRowStyles: { fillColor: [240, 249, 255] },
//           });
//         });

//         doc.save(`${fileName}_FullReport.pdf`);
//       } else if (format === "docx") {
//         const headerContent = includeHeader
//           ? `
//           <div style="font-family: Arial, sans-serif; text-align: center; margin-bottom: 20px; border-bottom: 2px solid #3182CE; padding-bottom: 10px;">
//             <h1 style="font-size: 26px; margin: 5px 0; color: #2D3748;">${
//               schoolDetails.schoolName
//             }</h1>
//             <p style="font-size: 16px; margin: 5px 0; color: #4A5568;">Email: ${
//               schoolDetails.email
//             }</p>
//             <p style="font-size: 16px; margin: 5px 0; color: #4A5568;">Year: ${year}</p>
//             <h2 style="font-size: 22px; margin: 5px 0; color: #3182CE;">${grade} - Term ${term} - ${getExamDisplayTitle(
//               examType,
//               examName
//             )}</h2>
//           </div>
//         `
//           : "";

//         let htmlContent = `
//           <div style="font-family: Arial, sans-serif; padding: 30px; line-height: 1.6;">
//             ${!includeHeader ? headerContent : ""}
//         `;

//         if (streams.length > 0) {
//           htmlContent += `
//             <h3 style="font-size: 20px; color: #2D3748; margin-bottom: 15px; border-bottom: 1px solid #E2E8F0;">Subject Analysis by Stream</h3>
//             <table style="width: 100%; border-collapse: collapse; margin-top: 12px; border: 1px solid #E2E8F0;">
//               <thead>
//                 <tr style="background-color: #3182CE; color: #FFFFFF;">
//                   <th style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">Stream</th>
//                   ${displaySubjects
//                     .map(
//                       (subject) =>
//                         `<th style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${getShortSubjectName(
//                           subject
//                         )}</th>`
//                     )
//                     .join("")}
//                   <th style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">Total</th>
//                   <th style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">Average</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 ${streams
//                   .sort()
//                   .map((stream) => {
//                     const averages = subjectAveragesByStream[stream].map(
//                       (item) => item.average || 0
//                     );
//                     const streamTotal = averages.reduce((sum, v) => sum + v, 0);
//                     const streamAvg =
//                       subjects.length > 0 ? streamTotal / subjects.length : 0;
//                     return `
//                     <tr>
//                       <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${stream}</td>
//                       ${averages
//                         .map(
//                           (avg) =>
//                             `<td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${avg.toFixed(
//                               2
//                             )}</td>`
//                         )
//                         .join("")}
//                       <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0; font-weight: bold;">${streamTotal.toFixed(
//                         2
//                       )}</td>
//                       <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0; font-weight: bold;">${streamAvg.toFixed(
//                         2
//                       )}</td>
//                     </tr>
//                   `;
//                   })
//                   .join("")}
//                 ${(() => {
//                   const overallAverages = subjectAverages.map(
//                     (item) => item.average || 0
//                   );
//                   const overallTotal = overallAverages.reduce(
//                     (sum, v) => sum + v,
//                     0
//                   );
//                   const overallAvg =
//                     subjects.length > 0 ? overallTotal / subjects.length : 0;
//                   return `
//                     <tr style="background-color: #F0F9FF; font-weight: bold;">
//                       <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">Overall</td>
//                       ${overallAverages
//                         .map(
//                           (avg) =>
//                             `<td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${avg.toFixed(
//                               2
//                             )}</td>`
//                         )
//                         .join("")}
//                       <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${overallTotal.toFixed(
//                         2
//                       )}</td>
//                       <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${overallAvg.toFixed(
//                         2
//                       )}</td>
//                     </tr>
//                   `;
//                 })()}
//               </tbody>
//             </table>
//           `;
//         }

//         htmlContent += `
//             <h3 style="font-size: 20px; color: #2D3748; margin: 20px 0 15px; border-bottom: 1px solid #E2E8F0;">Top Performers by Subject</h3>
//             <table style="width: 100%; border-collapse: collapse; margin-top: 12px; border: 1px solid #E2E8F0;">
//               <thead>
//                 <tr style="background-color: #3182CE; color: #FFFFFF;">
//                   <th style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">Student</th>
//                   <th style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">Subject</th>
//                   <th style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">Score (%)</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 ${Object.entries(topStudentsBySubject)
//                   .flatMap(([subject, students]) =>
//                     students.map(
//                       (student) => `
//                     <tr>
//                       <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${
//                         student.name
//                       } (${student.stream || "No Stream"})</td>
//                       <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${getShortSubjectName(
//                         subject
//                       )}</td>
//                       <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${
//                         student.score
//                       }</td>
//                     </tr>
//                   `
//                     )
//                   )
//                   .join("")}
//               </tbody>
//             </table>

//             <h3 style="font-size: 20px; color: #2D3748; margin: 20px 0 15px; border-bottom: 1px solid #E2E8F0;">Detailed Results - All Students</h3>
//             <table style="width: 100%; border-collapse: collapse; margin-top: 12px; border: 1px solid #E2E8F0;">
//               <thead>
//                 <tr style="background-color: #3182CE; color: #FFFFFF;">
//                   <th style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">No.</th>
//                   <th style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">Student</th>
//                   ${displaySubjects
//                     .map(
//                       (subject) =>
//                         `<th style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${getShortSubjectName(
//                           subject
//                         )}</th>`
//                     )
//                     .join("")}
//                   <th style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">Total</th>
//                   <th style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">Position</th>
//                   <th style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">Prev. Positions</th>
//                   <th style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">Stream</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 ${learnersByStream["General"]
//                   .map(
//                     (learner, index) => `
//                   <tr>
//                     <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${
//                       index + 1
//                     }</td>
//                     <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${
//                       learner.learnerName
//                     }${learner.stream ? ` (${learner.stream})` : ""}</td>
//                     ${subjects
//                       .map(
//                         (subject) =>
//                           `<td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${
//                             learner.marks[subject] || "-"
//                           }</td>`
//                       )
//                       .join("")}
//                     <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0; font-weight: bold;">${
//                       learner.total
//                     }</td>
//                     <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${
//                       learner.position
//                     }</td>
//                     <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${previousExamKeys
//                       .map((key) => learner.previousPositions[key] ?? "-")
//                       .join(",")}</td>
//                     <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${
//                       learner.stream || "No Stream"
//                     }</td>
//                   </tr>
//                 `
//                   )
//                   .join("")}
//                 <tr style="background-color: #F0F9FF; font-weight: bold;">
//                   <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">-</td>
//                   <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">Mean</td>
//                   ${displaySubjects
//                     .map(
//                       (subject) =>
//                         `<td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${generalMeanRow.displayMarks[subject]}</td>`
//                     )
//                     .join("")}
//                   <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0; font-weight: bold;">${
//                     generalMeanRow.total
//                   }</td>
//                   <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">-</td>
//                   <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">-</td>
//                   <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">-</td>
//                 </tr>
//               </tbody>
//             </table>
//             ${streams
//               .sort()
//               .map(
//                 (stream) => `
//               <h3 style="font-size: 20px; color: #2D3748; margin: 20px 0 15px; border-bottom: 1px solid #E2E8F0;">Detailed Results - Stream ${stream}</h3>
//               <table style="width: 100%; border-collapse: collapse; margin-top: 12px; border: 1px solid #E2E8F0;">
//                 <thead>
//                   <tr style="background-color: #3182CE; color: #FFFFFF;">
//                     <th style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">No.</th>
//                     <th style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">Student</th>
//                     ${displaySubjects
//                       .map(
//                         (subject) =>
//                           `<th style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${getShortSubjectName(
//                             subject
//                           )}</th>`
//                       )
//                       .join("")}
//                     <th style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">Total</th>
//                     <th style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">Position</th>
//                     <th style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">Prev. Positions</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   ${learnersByStream[stream]
//                     .map(
//                       (learner, index) => `
//                     <tr>
//                       <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${
//                         index + 1
//                       }</td>
//                       <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${
//                         learner.learnerName
//                       }</td>
//                       ${subjects
//                         .map(
//                           (subject) =>
//                             `<td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${
//                               learner.marks[subject] || "-"
//                             }</td>`
//                         )
//                         .join("")}
//                       <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0; font-weight: bold;">${
//                         learner.total
//                       }</td>
//                       <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${
//                         learner.position
//                       }</td>
//                       <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${previousExamKeys
//                         .map((key) => learner.previousPositions[key] ?? "-")
//                         .join(",")}</td>
//                     </tr>
//                   `
//                     )
//                     .join("")}
//                   <tr style="background-color: #F0F9FF; font-weight: bold;">
//                     <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">-</td>
//                     <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">Mean</td>
//                     ${displaySubjects
//                       .map(
//                         (subject) =>
//                           `<td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${streamMeanRows[stream].displayMarks[subject]}</td>`
//                       )
//                       .join("")}
//                     <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0; font-weight: bold;">${
//                       streamMeanRows[stream].total
//                     }</td>
//                     <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">-</td>
//                     <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">-</td>
//                   </tr>
//                 </tbody>
//               </table>
//             `
//               )
//               .join("")}
//           </div>
//         `;
//         const docx = htmlDocx.asBlob(htmlContent);
//         const url = URL.createObjectURL(docx);
//         const a = document.createElement("a");
//         a.href = url;
//         a.download = `${fileName}_FullReport.docx`;
//         a.click();
//         URL.revokeObjectURL(url);
//       } else if (format === "csv") {
//         let csvContent = generateCSVContent(
//           learnersByStream["General"],
//           "General",
//           "general"
//         );
//         // Append per stream detailed results for full CSV
//         streams.sort().forEach((stream) => {
//           csvContent +=
//             "\n\n" +
//             generateCSVContent(learnersByStream[stream], stream, "stream")
//               .split("\n")
//               .slice(6)
//               .join("\n"); // Skip header for per stream
//         });
//         const blob = new Blob([csvContent], {
//           type: "text/csv;charset=utf-8;",
//         });
//         const url = URL.createObjectURL(blob);
//         const a = document.createElement("a");
//         a.href = url;
//         a.download = `${fileName}_FullReport.csv`;
//         a.click();
//         URL.revokeObjectURL(url);
//       }
//     } catch (error) {
//       console.error(`Error generating ${format} report:`, error);
//       alert(`Failed to generate ${format} report. Please try again.`);
//     } finally {
//       setIsGenerating((prev) => ({ ...prev, general: false }));
//     }
//   };

//   if (isLoading) {
//     return (
//       <Box
//         sx={{
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           height: "100vh",
//           flexDirection: "column",
//         }}
//       >
//         <CircularProgress color="primary" />
//         <Typography sx={{ mt: 2, color: "#4A5568" }}>
//           Loading and Analyzing Performance Data...
//         </Typography>
//       </Box>
//     );
//   }

//   return (
//     <Container
//       maxWidth="lg"
//       sx={{ py: 4, bgcolor: "#f8f9fa", minHeight: "100vh" }}
//     >
//       <motion.div
//         initial={{ opacity: 0 }}
//         animate={{ opacity: 1 }}
//         transition={{ duration: 0.5 }}
//       >
//         <Typography
//           variant="h4"
//           sx={{
//             fontWeight: "bold",
//             color: "#2c3e50",
//             mb: 2,
//             textAlign: "center",
//           }}
//         >
//           {schoolDetails.schoolName} - {grade} - Term {term} -{" "}
//           {getExamDisplayTitle(examType, examName)}
//         </Typography>

//         {/* ADD THE EXAM SELECTION BUTTON HERE */}
//         {renderExamSelectionButton()}
//         <Paper
//           sx={{ p: 2, mb: 3, bgcolor: "#fff", border: "1px solid #E2E8F0" }}
//         >
//           <Typography variant="h6" sx={{ fontWeight: "600", color: "#2D3748" }}>
//             {schoolDetails.schoolName}
//           </Typography>
//           <Typography sx={{ color: "#4A5568" }}>
//             <strong>Exam:</strong> {getExamDisplayTitle(examType, examName)}
//           </Typography>
//           <Typography sx={{ color: "#4A5568" }}>
//             <strong>School Code:</strong> {schoolDetails.schoolCode}
//           </Typography>
//           <Typography sx={{ color: "#4A5568" }}>
//             <strong>Address:</strong>{" "}
//             {[
//               schoolDetails.village,
//               schoolDetails.location,
//               schoolDetails.subcounty,
//               schoolDetails.county,
//             ]
//               .filter(Boolean)
//               .join(", ")}
//           </Typography>
//           <Typography sx={{ color: "#4A5568" }}>
//             <strong>Physical Address:</strong> {schoolDetails.address}
//           </Typography>
//           <Typography sx={{ color: "#4A5568" }}>
//             <strong>Contact:</strong> {schoolDetails.phoneNumber}
//           </Typography>
//           <Typography sx={{ color: "#4A5568" }}>
//             <strong>Email:</strong> {schoolDetails.email}
//           </Typography>
//           <Typography sx={{ color: "#4A5568" }}>
//             <strong>Website:</strong> {schoolDetails.website}
//           </Typography>
//         </Paper>

//         {/* Performance Overview */}
//         <Paper
//           sx={{ p: 3, mb: 3, bgcolor: "#fff", border: "1px solid #E2E8F0" }}
//         >
//           <Typography
//             variant="h5"
//             sx={{ fontWeight: "600", color: "#2D3748", mb: 2 }}
//           >
//             Performance Overview
//           </Typography>
//           {streams.length > 0 && (
//             <Box
//               sx={{
//                 mb: 3,
//                 p: 2,
//                 bgcolor: "#F7FAFC",
//                 borderRadius: 2,
//                 border: "1px solid #E2E8F0",
//               }}
//             >
//               <Typography sx={{ fontWeight: "500", color: "#4A5568", mb: 2 }}>
//                 Stream Rankings
//               </Typography>
//               {streamAverages.map(({ stream, average, count }, index) => (
//                 <Box
//                   key={stream}
//                   sx={{
//                     display: "flex",
//                     alignItems: "center",
//                     py: 1,
//                     borderBottom: "1px solid #E2E8F0",
//                   }}
//                 >
//                   <Typography
//                     sx={{ width: 60, fontWeight: "600", color: "#2D3748" }}
//                   >
//                     #{index + 1}
//                   </Typography>
//                   <Typography
//                     sx={{ flex: 1, fontWeight: "500", color: "#2D3748" }}
//                   >
//                     {stream}
//                   </Typography>
//                   <Typography
//                     sx={{
//                       width: 70,
//                       textAlign: "right",
//                       fontWeight: "600",
//                       color: "#3182CE",
//                     }}
//                   >
//                     {average}%
//                   </Typography>
//                   <Typography
//                     sx={{
//                       width: 80,
//                       textAlign: "right",
//                       color: "#718096",
//                       fontSize: "0.85rem",
//                     }}
//                   >
//                     ({count} students)
//                   </Typography>
//                 </Box>
//               ))}
//             </Box>
//           )}
//           <Box sx={{ mb: 3 }}>
//             <Typography sx={{ fontWeight: "500", color: "#4A5568", mb: 2 }}>
//               Subject Averages
//             </Typography>
//             <Box sx={{ maxWidth: 400, mx: "auto" }}>
//               <Pie
//                 data={pieData}
//                 options={{ plugins: { legend: { position: "bottom" } } }}
//               />
//             </Box>
//           </Box>
//           <Box>
//             <Typography sx={{ fontWeight: "500", color: "#4A5568", mb: 2 }}>
//               Comparison of Averages
//             </Typography>
//             <Bar
//               data={barData}
//               options={{
//                 plugins: { legend: { display: false } },
//                 scales: {
//                   y: {
//                     beginAtZero: true,
//                     title: { display: true, text: "Average (%)" },
//                   },
//                 },
//               }}
//             />
//           </Box>
//         </Paper>

//         {/* Subject Analysis by Stream */}
//         {streams.length > 0 && (
//           <Paper
//             sx={{ p: 3, mb: 3, bgcolor: "#fff", border: "1px solid #E2E8F0" }}
//           >
//             <Typography
//               variant="h5"
//               sx={{ fontWeight: "600", color: "#2D3748", mb: 2 }}
//             >
//               Subject Analysis by Stream
//             </Typography>
//             {displaySubjects.map((subject) => (
//               <Accordion
//                 key={subject}
//                 sx={{ mb: 2, bgcolor: "#fff", border: "1px solid #E2E8F0" }}
//               >
//                 <AccordionSummary expandIcon={<ExpandMore />}>
//                   <Typography sx={{ fontWeight: "600", color: "#2D3748" }}>
//                     {getShortSubjectName(subject)}
//                   </Typography>
//                 </AccordionSummary>
//                 <AccordionDetails>
//                   <Box sx={{ maxWidth: 400, mx: "auto", mb: 2 }}>
//                     <Pie
//                       data={prepareSubjectComparisonData(subject)}
//                       options={{ plugins: { legend: { position: "bottom" } } }}
//                     />
//                   </Box>
//                   <TableContainer>
//                     <Table>
//                       <TableHead>
//                         <TableRow sx={{ bgcolor: "#E2E8F0" }}>
//                           <TableCell
//                             sx={{ fontWeight: "600", color: "#2D3748" }}
//                           >
//                             Stream
//                           </TableCell>
//                           <TableCell
//                             sx={{ fontWeight: "600", color: "#2D3748" }}
//                           >
//                             Average
//                           </TableCell>
//                           <TableCell
//                             sx={{ fontWeight: "600", color: "#2D3748" }}
//                           >
//                             Students
//                           </TableCell>
//                         </TableRow>
//                       </TableHead>
//                       <TableBody>
//                         {streams.sort().map((stream) => {
//                           const streamAvg = subjectAveragesByStream[
//                             stream
//                           ].find((item) => item.subject === subject);
//                           return (
//                             <TableRow key={stream}>
//                               <TableCell>{stream}</TableCell>
//                               <TableCell>{streamAvg?.average || 0}</TableCell>
//                               <TableCell>{streamAvg?.count || 0}</TableCell>
//                             </TableRow>
//                           );
//                         })}
//                       </TableBody>
//                     </Table>
//                   </TableContainer>
//                 </AccordionDetails>
//               </Accordion>
//             ))}
//           </Paper>
//         )}

//         {/* Top Performers */}
//         <Paper
//           sx={{ p: 3, mb: 3, bgcolor: "#fff", border: "1px solid #E2E8F0" }}
//         >
//           <Typography
//             variant="h5"
//             sx={{ fontWeight: "600", color: "#2D3748", mb: 2 }}
//           >
//             Top Performers
//           </Typography>
//           {topPerformers.map((performer) => (
//             <Box
//               key={performer.learnerId}
//               sx={{
//                 p: 2,
//                 mb: 2,
//                 bgcolor: "#F7FAFC",
//                 borderRadius: 2,
//                 borderLeft: "4px solid #3182CE",
//               }}
//             >
//               <Typography
//                 sx={{
//                   fontWeight: "600",
//                   color: "#2D3748",
//                   cursor: "pointer",
//                   "&:hover": { textDecoration: "underline" },
//                 }}
//                 onClick={() =>
//                   navigate("/student-detailed-analysis", {
//                     state: {
//                       learnerId: performer.learnerId,
//                       learnerName: performer.learnerName,
//                       schoolId,
//                       grade,
//                     },
//                   })
//                 }
//               >
//                 {performer.learnerName}
//               </Typography>
//               <Typography sx={{ color: "#3182CE", fontWeight: "500" }}>
//                 Position: {performer.position} | Total: {performer.total} marks
//                 | Mean: {performer.mean}%
//                 {performer.stream && ` | Stream: ${performer.stream}`}
//               </Typography>
//               <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
//                 {displaySubjects.map((displaySubject, index) => (
//                   <Chip
//                     key={displaySubject}
//                     label={`${getShortSubjectName(displaySubject)}: ${
//                       performer.marks[subjects[index]] || "N/A"
//                     }`}
//                     sx={{ bgcolor: "#e0e0e0", fontSize: "0.75rem" }}
//                   />
//                 ))}
//               </Box>
//             </Box>
//           ))}
//         </Paper>

//         {/* Top Students by Subject */}
//         <Paper
//           sx={{ p: 3, mb: 3, bgcolor: "#fff", border: "1px solid #E2E8F0" }}
//         >
//           <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
//             <Typography
//               variant="h5"
//               sx={{ fontWeight: "600", color: "#2D3748", mr: 2 }}
//             >
//               Top Students by Subject
//             </Typography>
//             <FormControl sx={{ minWidth: 120 }}>
//               <InputLabel>Top N</InputLabel>
//               <Select
//                 value={topN}
//                 label="Top N"
//                 onChange={(e) => setTopN(e.target.value)}
//               >
//                 <MenuItem value={1}>Top 1</MenuItem>
//                 <MenuItem value={2}>Top 2</MenuItem>
//                 <MenuItem value={3}>Top 3</MenuItem>
//               </Select>
//             </FormControl>
//           </Box>
//           {displaySubjects.map((subject) => (
//             <Box
//               key={subject}
//               sx={{
//                 mb: 2,
//                 p: 2,
//                 bgcolor: "#fff",
//                 border: "1px solid #E2E8F0",
//                 borderRadius: 2,
//               }}
//             >
//               <Typography sx={{ fontWeight: "600", color: "#2D3748", mb: 1 }}>
//                 {getShortSubjectName(subject)}
//               </Typography>
//               {topStudentsBySubject[subject].map((student, index) => (
//                 <Typography
//                   key={index}
//                   sx={{
//                     color: "#3182CE",
//                     fontWeight: "500",
//                     cursor: "pointer",
//                     "&:hover": { textDecoration: "underline" },
//                   }}
//                   onClick={() =>
//                     navigate("/student-detailed-analysis", {
//                       state: {
//                         learnerId: student.learnerId,
//                         learnerName: student.name,
//                         schoolId,
//                         grade,
//                       },
//                     })
//                   }
//                 >
//                   {student.name}
//                   {student.stream && ` (${student.stream})`}: {student.score}%
//                 </Typography>
//               ))}
//             </Box>
//           ))}
//         </Paper>

//         {/* Detailed Results */}
//         {/* Detailed Results */}
//         <Paper
//           sx={{ p: 3, mb: 3, bgcolor: "#fff", border: "1px solid #E2E8F0" }}
//         >
//           <Typography
//             variant="h5"
//             sx={{ fontWeight: "600", color: "#2D3748", mb: 2 }}
//           >
//             Detailed Results
//           </Typography>

//           <TableContainer>
//             <Table>
//               <TableHead>
//                 <TableRow sx={{ bgcolor: "#3182CE" }}>
//                   <TableCell
//                     sx={{ color: "#fff", fontWeight: "600", width: 50 }}
//                   >
//                     No.
//                   </TableCell>
//                   <TableCell sx={{ color: "#fff", fontWeight: "600" }}>
//                     Student
//                   </TableCell>
//                   {displaySubjects.map((subject) => (
//                     <TableCell
//                       key={subject}
//                       sx={{ color: "#fff", fontWeight: "600" }}
//                     >
//                       {getShortSubjectName(subject)}
//                     </TableCell>
//                   ))}
//                   <TableCell sx={{ color: "#fff", fontWeight: "600" }}>
//                     Total
//                   </TableCell>
//                   <TableCell
//                     sx={{ color: "#fff", fontWeight: "600", width: 60 }}
//                   >
//                     Pos
//                   </TableCell>

//                   {/* Previous Position Headers */}
//                   {selectedPreviousExams.map((exam, index) => {
//                     const displayName = getExamDisplayTitle(
//                       exam.examType,
//                       exam.examName
//                     );
//                     return (
//                       <TableCell
//                         key={exam._id || index}
//                         sx={{
//                           color: "#fff",
//                           fontWeight: "600",
//                           textAlign: "center",
//                           minWidth: 80,
//                         }}
//                       >
//                         {displayName}
//                       </TableCell>
//                     );
//                   })}

//                   <TableCell sx={{ color: "#fff", fontWeight: "600" }}>
//                     Stream
//                   </TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {learnersByStream["General"].map((learner, index) => (
//                   <TableRow key={learner.learnerId}>
//                     <TableCell sx={{ fontWeight: "600" }}>
//                       {index + 1}
//                     </TableCell>
//                     <TableCell>
//                       <Typography
//                         sx={{
//                           cursor: "pointer",
//                           "&:hover": { textDecoration: "underline" },
//                         }}
//                         onClick={() =>
//                           navigate("/student-detailed-analysis", {
//                             state: {
//                               learnerId: learner.learnerId,
//                               learnerName: learner.learnerName,
//                               schoolId,
//                               grade,
//                             },
//                           })
//                         }
//                       >
//                         {learner.learnerName}
//                         {learner.stream && ` (${learner.stream})`}
//                       </Typography>
//                     </TableCell>
//                     {subjects.map((subject) => (
//                       <TableCell key={subject}>
//                         {learner.marks[subject] || "-"}
//                       </TableCell>
//                     ))}
//                     <TableCell sx={{ fontWeight: "600" }}>
//                       {learner.total}
//                     </TableCell>
//                     <TableCell>{learner.position}</TableCell>

//                     {/* Previous Position Cells */}
//                     {selectedPreviousExams.map((exam, idx) => {
//                       const examKey = `${exam.term}-${exam.examType}-${
//                         exam.examName || ""
//                       }`;
//                       const position = learner.previousPositions[examKey];
//                       return (
//                         <TableCell
//                           key={exam._id || idx}
//                           sx={{ textAlign: "center" }}
//                         >
//                           {position || (position === 0 ? "0" : "-")}
//                         </TableCell>
//                       );
//                     })}

//                     <TableCell>{learner.stream || "No Stream"}</TableCell>
//                   </TableRow>
//                 ))}

//                 {/* Mean Row */}
//                 <TableRow sx={{ bgcolor: "#F0F9FF" }}>
//                   <TableCell sx={{ fontWeight: "600" }}>-</TableCell>
//                   <TableCell sx={{ fontWeight: "600" }}>Mean</TableCell>
//                   {displaySubjects.map((subject) => (
//                     <TableCell key={subject} sx={{ fontWeight: "600" }}>
//                       {subjectAverages.find((s) => s.subject === subject)
//                         ?.average || 0}
//                     </TableCell>
//                   ))}
//                   <TableCell sx={{ fontWeight: "700", color: "#3182CE" }}>
//                     {Number(
//                       (
//                         processedLearners.reduce(
//                           (sum, learner) => sum + learner.total,
//                           0
//                         ) / (processedLearners.length || 1)
//                       ).toFixed(2)
//                     )}
//                   </TableCell>
//                   <TableCell sx={{ fontWeight: "600" }}>-</TableCell>
//                   {/* Empty cells for previous positions in mean row */}
//                   {selectedPreviousExams.map((_, idx) => (
//                     <TableCell key={idx} sx={{ fontWeight: "600" }}>
//                       -
//                     </TableCell>
//                   ))}
//                   <TableCell sx={{ fontWeight: "600" }}>-</TableCell>
//                 </TableRow>
//               </TableBody>
//             </Table>
//           </TableContainer>

//           <Box sx={{ mt: 2, display: "flex", alignItems: "center", gap: 2 }}>
//             <Button
//               variant="contained"
//               sx={{ bgcolor: "#3182CE" }}
//               onClick={() => createDocument("General", "general", "pdf")}
//               disabled={isGenerating.general}
//             >
//               {isGenerating.general ? (
//                 <CircularProgress size={24} color="inherit" />
//               ) : (
//                 "Download General Results (PDF)"
//               )}
//             </Button>
//             <Button
//               variant="outlined"
//               onClick={() => createDocument("General", "general", "docx")}
//               disabled={isGenerating.general}
//             >
//               {isGenerating.general ? (
//                 <CircularProgress size={24} color="inherit" />
//               ) : (
//                 "Download (DOCX)"
//               )}
//             </Button>
//             <Button
//               variant="outlined"
//               onClick={() => createDocument("General", "general", "csv")}
//               disabled={isGenerating.general}
//             >
//               {isGenerating.general ? (
//                 <CircularProgress size={24} color="inherit" />
//               ) : (
//                 "Download (CSV)"
//               )}
//             </Button>
//             <FormControlLabel
//               control={
//                 <Checkbox
//                   checked={includeHeader}
//                   onChange={(e) => setIncludeHeader(e.target.checked)}
//                 />
//               }
//               label="Include header on every page"
//             />
//           </Box>

//           {/* Stream-specific tables */}
//           {streams.sort().map((stream) => (
//             <Box key={stream} sx={{ mt: 3 }}>
//               <Typography sx={{ fontWeight: "600", color: "#2D3748", mb: 1 }}>
//                 Stream: {stream}
//               </Typography>
//               <TableContainer>
//                 <Table>
//                   <TableHead>
//                     <TableRow sx={{ bgcolor: "#3182CE" }}>
//                       <TableCell
//                         sx={{ color: "#fff", fontWeight: "600", width: 50 }}
//                       >
//                         No.
//                       </TableCell>
//                       <TableCell sx={{ color: "#fff", fontWeight: "600" }}>
//                         Student
//                       </TableCell>
//                       {displaySubjects.map((subject) => (
//                         <TableCell
//                           key={subject}
//                           sx={{ color: "#fff", fontWeight: "600" }}
//                         >
//                           {getShortSubjectName(subject)}
//                         </TableCell>
//                       ))}
//                       <TableCell sx={{ color: "#fff", fontWeight: "600" }}>
//                         Total
//                       </TableCell>
//                       <TableCell
//                         sx={{ color: "#fff", fontWeight: "600", width: 60 }}
//                       >
//                         Pos
//                       </TableCell>
//                       {selectedPreviousExams.map((exam, index) => {
//                         const displayName = getExamDisplayTitle(
//                           exam.examType,
//                           exam.examName
//                         );
//                         return (
//                           <TableCell
//                             key={exam._id || index}
//                             sx={{
//                               color: "#fff",
//                               fontWeight: "600",
//                               textAlign: "center",
//                             }}
//                           >
//                             {displayName}
//                           </TableCell>
//                         );
//                       })}
//                     </TableRow>
//                   </TableHead>
//                   <TableBody>
//                     {learnersByStream[stream].map((learner, index) => (
//                       <TableRow key={learner.learnerId}>
//                         <TableCell sx={{ fontWeight: "600" }}>
//                           {index + 1}
//                         </TableCell>
//                         <TableCell>
//                           <Typography
//                             sx={{
//                               cursor: "pointer",
//                               "&:hover": { textDecoration: "underline" },
//                             }}
//                             onClick={() =>
//                               navigate("/student-detailed-analysis", {
//                                 state: {
//                                   learnerId: learner.learnerId,
//                                   learnerName: learner.learnerName,
//                                   schoolId,
//                                   grade,
//                                 },
//                               })
//                             }
//                           >
//                             {String(learner.learnerName || "N/A")}
//                           </Typography>
//                         </TableCell>
//                         {subjects.map((subject) => (
//                           <TableCell key={subject}>
//                             {String(learner.marks[subject] ?? "-")}
//                           </TableCell>
//                         ))}
//                         <TableCell sx={{ fontWeight: "600" }}>
//                           {String(learner.total ?? "-")}
//                         </TableCell>
//                         <TableCell>{learner.position || "-"}</TableCell>
//                         {selectedPreviousExams.map((exam, idx) => {
//                           const examKey = `${exam.term}-${exam.examType}-${
//                             exam.examName || ""
//                           }`;
//                           const position = learner.previousPositions[examKey];
//                           return (
//                             <TableCell
//                               key={exam._id || idx}
//                               sx={{ textAlign: "center" }}
//                             >
//                               {position || (position === 0 ? "0" : "-")}
//                             </TableCell>
//                           );
//                         })}
//                       </TableRow>
//                     ))}
//                     <TableRow sx={{ bgcolor: "#F0F9FF" }}>
//                       <TableCell sx={{ fontWeight: "600" }}>-</TableCell>
//                       <TableCell sx={{ fontWeight: "600" }}>Mean</TableCell>
//                       {displaySubjects.map((subject) => (
//                         <TableCell key={subject} sx={{ fontWeight: "600" }}>
//                           {subjectAveragesByStream[stream].find(
//                             (s) => s.subject === subject
//                           )?.average || 0}
//                         </TableCell>
//                       ))}
//                       <TableCell sx={{ fontWeight: "700", color: "#3182CE" }}>
//                         {Number(
//                           (
//                             learnersByStream[stream].reduce(
//                               (sum, learner) => sum + (learner.total || 0),
//                               0
//                             ) / (learnersByStream[stream].length || 1)
//                           ).toFixed(2)
//                         ) || 0}
//                       </TableCell>
//                       <TableCell sx={{ fontWeight: "600" }}>-</TableCell>
//                       {selectedPreviousExams.map((_, idx) => (
//                         <TableCell key={idx} sx={{ fontWeight: "600" }}>
//                           -
//                         </TableCell>
//                       ))}
//                     </TableRow>
//                   </TableBody>
//                 </Table>
//               </TableContainer>
//               <Box
//                 sx={{ mt: 2, display: "flex", alignItems: "center", gap: 2 }}
//               >
//                 <Button
//                   variant="contained"
//                   sx={{ bgcolor: "#3182CE" }}
//                   onClick={() => createDocument(stream, "stream", "pdf")}
//                   disabled={isGenerating.streams[stream]}
//                 >
//                   {isGenerating.streams[stream] ? (
//                     <CircularProgress size={24} color="inherit" />
//                   ) : (
//                     "Download Stream Report (PDF)"
//                   )}
//                 </Button>
//                 <Button
//                   variant="outlined"
//                   onClick={() => createDocument(stream, "stream", "docx")}
//                   disabled={isGenerating.streams[stream]}
//                 >
//                   {isGenerating.streams[stream] ? (
//                     <CircularProgress size={24} color="inherit" />
//                   ) : (
//                     "Download (DOCX)"
//                   )}
//                 </Button>
//                 <Button
//                   variant="outlined"
//                   onClick={() => createDocument(stream, "stream", "csv")}
//                   disabled={isGenerating.streams[stream]}
//                 >
//                   {isGenerating.streams[stream] ? (
//                     <CircularProgress size={24} color="inherit" />
//                   ) : (
//                     "Download (CSV)"
//                   )}
//                 </Button>
//                 <FormControlLabel
//                   control={
//                     <Checkbox
//                       checked={includeHeader}
//                       onChange={(e) => setIncludeHeader(e.target.checked)}
//                     />
//                   }
//                   label="Include header on every page"
//                 />
//               </Box>
//             </Box>
//           ))}
//         </Paper>

//         {streams.sort().map((stream) => (
//           <Box key={stream} sx={{ mt: 3 }}>
//             <Typography sx={{ fontWeight: "600", color: "#2D3748", mb: 1 }}>
//               Stream: {stream}
//             </Typography>
//             <TableContainer>
//               <Table>
//                 <TableHead>
//                   <TableRow sx={{ bgcolor: "#3182CE" }}>
//                     <TableCell
//                       sx={{ color: "#fff", fontWeight: "600", width: 50 }}
//                     >
//                       No.
//                     </TableCell>
//                     <TableCell sx={{ color: "#fff", fontWeight: "600" }}>
//                       Student
//                     </TableCell>
//                     {displaySubjects.map((subject) => (
//                       <TableCell
//                         key={subject}
//                         sx={{ color: "#fff", fontWeight: "600" }}
//                       >
//                         {getShortSubjectName(subject)}
//                       </TableCell>
//                     ))}
//                     <TableCell sx={{ color: "#fff", fontWeight: "600" }}>
//                       Total
//                     </TableCell>
//                     <TableCell
//                       sx={{ color: "#fff", fontWeight: "600", width: 60 }}
//                     >
//                       Pos
//                     </TableCell>
//                     {previousExamKeys.map((examKey, idx) => {
//                       const [examTerm, examType, examName] = examKey.split("-");
//                       const displayName = examName
//                         ? `${examTerm}:${examName}`
//                         : examTerm;

//                       return (
//                         <TableCell
//                           key={idx}
//                           sx={{
//                             color: "#fff",
//                             fontWeight: "600",
//                             textAlign: "center",
//                           }}
//                         >
//                           {displayName}
//                         </TableCell>
//                       );
//                     })}
//                   </TableRow>
//                 </TableHead>
//                 <TableBody>
//                   {learnersByStream[stream].map((learner, index) => (
//                     <TableRow key={learner.learnerId}>
//                       <TableCell sx={{ fontWeight: "600" }}>
//                         {index + 1}
//                       </TableCell>
//                       <TableCell>
//                         <Typography
//                           sx={{
//                             cursor: "pointer",
//                             "&:hover": { textDecoration: "underline" },
//                           }}
//                           onClick={() =>
//                             navigate("/student-detailed-analysis", {
//                               state: {
//                                 learnerId: learner.learnerId,
//                                 learnerName: learner.learnerName,
//                                 schoolId,
//                                 grade,
//                               },
//                             })
//                           }
//                         >
//                           {String(learner.learnerName || "N/A")}
//                         </Typography>
//                       </TableCell>
//                       {subjects.map((subject) => (
//                         <TableCell key={subject}>
//                           {String(learner.marks[subject] ?? "-")}
//                         </TableCell>
//                       ))}
//                       <TableCell sx={{ fontWeight: "600" }}>
//                         {String(learner.total ?? "-")}
//                       </TableCell>
//                       <TableCell>{learner.position || "-"}</TableCell>
//                       {previousExamKeys.map((examKey, idx) => {
//                         const position = learner.previousPositions[examKey];
//                         return (
//                           <TableCell key={idx} sx={{ textAlign: "center" }}>
//                             {position || (position === 0 ? "0" : "-")}
//                           </TableCell>
//                         );
//                       })}
//                     </TableRow>
//                   ))}
//                   <TableRow sx={{ bgcolor: "#F0F9FF" }}>
//                     <TableCell sx={{ fontWeight: "600" }}>-</TableCell>
//                     <TableCell sx={{ fontWeight: "600" }}>Mean</TableCell>
//                     {displaySubjects.map((subject) => (
//                       <TableCell key={subject} sx={{ fontWeight: "600" }}>
//                         {subjectAveragesByStream[stream].find(
//                           (s) => s.subject === subject
//                         )?.average || 0}
//                       </TableCell>
//                     ))}
//                     <TableCell sx={{ fontWeight: "700", color: "#3182CE" }}>
//                       {Number(
//                         (
//                           learnersByStream[stream].reduce(
//                             (sum, learner) => sum + (learner.total || 0),
//                             0
//                           ) / (learnersByStream[stream].length || 1)
//                         ).toFixed(2)
//                       ) || 0}
//                     </TableCell>
//                     <TableCell sx={{ fontWeight: "600" }}>-</TableCell>
//                     {previousExamKeys.map((_, idx) => (
//                       <TableCell key={idx} sx={{ fontWeight: "600" }}>
//                         -
//                       </TableCell>
//                     ))}
//                   </TableRow>
//                 </TableBody>
//               </Table>
//             </TableContainer>
//             <Box sx={{ mt: 2, display: "flex", alignItems: "center", gap: 2 }}>
//               <Button
//                 variant="contained"
//                 sx={{ bgcolor: "#3182CE" }}
//                 onClick={() => createDocument(stream, "stream", "pdf")}
//                 disabled={isGenerating.streams[stream]}
//               >
//                 {isGenerating.streams[stream] ? (
//                   <CircularProgress size={24} color="inherit" />
//                 ) : (
//                   "Download Stream Report (PDF)"
//                 )}
//               </Button>
//               <Button
//                 variant="outlined"
//                 onClick={() => createDocument(stream, "stream", "docx")}
//                 disabled={isGenerating.streams[stream]}
//               >
//                 {isGenerating.streams[stream] ? (
//                   <CircularProgress size={24} color="inherit" />
//                 ) : (
//                   "Download (DOCX)"
//                 )}
//               </Button>
//               <Button
//                 variant="outlined"
//                 onClick={() => createDocument(stream, "stream", "csv")}
//                 disabled={isGenerating.streams[stream]}
//               >
//                 {isGenerating.streams[stream] ? (
//                   <CircularProgress size={24} color="inherit" />
//                 ) : (
//                   "Download (CSV)"
//                 )}
//               </Button>
//               <FormControlLabel
//                 control={
//                   <Checkbox
//                     checked={includeHeader}
//                     onChange={(e) => setIncludeHeader(e.target.checked)}
//                   />
//                 }
//                 label="Include header on every page"
//               />
//             </Box>
//           </Box>
//         ))}

//         <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
//           <Button
//             variant="contained"
//             sx={{ bgcolor: "#3182CE" }}
//             onClick={() => createFullPDF("pdf")}
//             disabled={isGenerating.general}
//           >
//             {isGenerating.general ? (
//               <CircularProgress size={24} color="inherit" />
//             ) : (
//               "Download Full Report (PDF)"
//             )}
//           </Button>
//           <Button
//             variant="outlined"
//             onClick={() => createFullPDF("docx")}
//             disabled={isGenerating.general}
//           >
//             {isGenerating.general ? (
//               <CircularProgress size={24} color="inherit" />
//             ) : (
//               "Download Full Report (DOCX)"
//             )}
//           </Button>
//           <Button
//             variant="outlined"
//             onClick={() => createFullPDF("csv")}
//             disabled={isGenerating.general}
//           >
//             {isGenerating.general ? (
//               <CircularProgress size={24} color="inherit" />
//             ) : (
//               "Download Full Report (CSV)"
//             )}
//           </Button>
//           <FormControlLabel
//             control={
//               <Checkbox
//                 checked={includeHeader}
//                 onChange={(e) => setIncludeHeader(e.target.checked)}
//               />
//             }
//             label="Include header on every page"
//           />
//         </Box>
//         <ExamSelectionModal
//           open={examSelectionOpen}
//           onClose={() => setExamSelectionOpen(false)}
//           onConfirm={handleExamSelectionConfirm}
//           schoolId={schoolId}
//           grade={grade}
//           currentExam={{
//             term,
//             examType,
//             examName: examName || null,
//           }}
//         />
//       </motion.div>
//     </Container>
//   );
// };

// export default PerformanceAnalysis;

import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useAuth } from "../components/auth/AuthContext";
import {
  Container,
  Typography,
  Box,
  CircularProgress,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import { ExpandMore, Settings } from "@mui/icons-material";
import axios from "axios";
import { Pie, Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from "chart.js";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import htmlDocx from "html-docx-js/dist/html-docx";
import ExamSelectionModal from "../pages/ExamSelectionModal";

// Register Chart.js components
ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
);

// Helper functions (KEEP ALL YOUR EXISTING HELPER FUNCTIONS HERE)
const getShortSubjectName = (subject) => {
  const shortNames = {
    Language: "Lang",
    Mathematics: "Math",
    "Psychomotor and Creative Arts": "PCA",
    Environmental: "Env",
    "Religious Education": "RE",
    "English Language": "Eng",
    "English Composition": "Comp",
    "Kiswahili Lugha": "Kisw",
    "Kiswahili Insha": "Insha",
    "Science and Technology": "Sci/Tech",
    "Science & Technology": "Sci/Tech",
    "Agriculture and Nutrition": "Agri/Nut",
    Agriculture: "Agri",
    "Social Studies": "SS",
    "Creative Arts & Sports": "CAS",
    "Creative Arts": "Arts",
    Science: "Sci",
    "Pre-Technical Studies": "PTS",
    "Pre-Technical": "Pre-Tech",
    "Number Work": "N/W",
    "Social Studies and Religious Education": "SS/RE",
    "Science and Environment": "Sci/Env",
    "Environmental Activities": "ARM",
    Kiswahili: "Kiswa",
    "Language/Total": "Lang/Total",
  };
  return shortNames[subject] || subject;
};

const getExamDisplayTitle = (examType, examName) => {
  if (examName && examName.trim() !== "" && examName !== "Unnamed") {
    return `${examType}: ${examName}`;
  }
  return examType;
};

const mapSubjectsToDisplay = (subjects, className) => {
  const displayOrder = {
    PG: [
      "Number Work",
      "Language/Total",
      "Reading/Jumla",
      "Creative",
      "Science and Environment",
      "Social Studies and Religious Education",
    ],
    "Grade PP1": [
      "Number Work",
      "Language/Total",
      "Kiswahili/Jumla",
      "Creative",
      "Science and Environment",
      "Social Studies and Religious Education",
    ],
    "Grade PP2": [
      "Number Work",
      "Language/Total",
      "Kiswahili/Jumla",
      "Creative",
      "Science and Environment",
      "Social Studies and Religious Education",
    ],
    "Grade 1": [
      "English",
      "Kiswahili",
      "Mathematics",
      "Science",
      "Social Studies and Religious Education",
      "Environmental Activities",
    ],
    "Grade 2": [
      "English",
      "Kiswahili",
      "Mathematics",
      "Science",
      "Social Studies and Religious Education",
      "Environmental Activities",
    ],
    "Grade 3": [
      "English",
      "Kiswahili",
      "Mathematics",
      "Science",
      "Social Studies and Religious Education",
      "Environmental Activities",
    ],
    "Grade 4": [
      "English Language",
      "English Composition",
      "Kiswahili Lugha",
      "Kiswahili Insha",
      "Mathematics",
      "Science & Technology",
      "Agriculture",
      "Social Studies",
      "Religious Education",
      "Creative Arts",
    ],
    "Grade 5": [
      "English Language",
      "English Composition",
      "Kiswahili Lugha",
      "Kiswahili Insha",
      "Mathematics",
      "Science & Technology",
      "Agriculture",
      "Social Studies",
      "Religious Education",
      "Creative Arts",
    ],
    "Grade 6": [
      "English Language",
      "English Composition",
      "Kiswahili Lugha",
      "Kiswahili Insha",
      "Mathematics",
      "Science & Technology",
      "Agriculture",
      "Social Studies",
      "Religious Education",
      "Creative Arts",
    ],
    "Grade 7": [
      "English Language",
      "English Composition",
      "Kiswahili Lugha",
      "Kiswahili Insha",
      "Mathematics",
      "Science & Technology",
      "Agriculture",
      "Social Studies",
      "Religious Education",
      "Creative Arts",
      "Pre-Technical",
    ],
    "Grade 8": [
      "English Language",
      "English Composition",
      "Kiswahili Lugha",
      "Kiswahili Insha",
      "Mathematics",
      "Science & Technology",
      "Agriculture",
      "Social Studies",
      "Religious Education",
      "Creative Arts",
      "Pre-Technical",
    ],
    "Grade 9": [
      "English Language",
      "English Composition",
      "Kiswahili Lugha",
      "Kiswahili Insha",
      "Mathematics",
      "Science & Technology",
      "Agriculture",
      "Social Studies",
      "Religious Education",
      "Creative Arts",
      "Pre-Technical",
    ],
  };

  const subjectMapping = {
    "Science and Technology": "Science & Technology",
    "Agriculture and Nutrition": "Agriculture",
    "Creative Arts & Sports": "Creative Arts",
    "Pre-Technical Studies": "Pre-Technical",
  };

  if (displayOrder[className]) {
    return displayOrder[className]
      .map((displaySubject) => {
        const dataSubject =
          Object.keys(subjectMapping).find(
            (key) => subjectMapping[key] === displaySubject
          ) || displaySubject;
        return subjects.includes(dataSubject)
          ? { dataSubject, displaySubject }
          : null;
      })
      .filter(Boolean);
  }

  return subjects.map((dataSubject) => ({
    dataSubject,
    displaySubject: subjectMapping[dataSubject] || dataSubject,
  }));
};

const PerformanceAnalysis = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { schoolId: contextSchoolId } = useAuth();
  const {
    grade,
    term,
    examType,
    examName,
    data,
    schoolId = contextSchoolId,
    isTermSummary = false,
  } = location.state || {};

  const dataSubjects = Array.from(data?.subjects || []);
  const subjectMap = mapSubjectsToDisplay(dataSubjects, grade);
  const subjects = subjectMap.map((item) => item.dataSubject);
  const displaySubjects = subjectMap.map((item) => item.displaySubject);

  const [topN, setTopN] = useState(1);
  const [isGenerating, setIsGenerating] = useState({
    general: false,
    streams: {},
  });
  const [schoolDetails, setSchoolDetails] = useState({
    schoolName: "",
    schoolCode: "",
    county: "",
    subcounty: "",
    location: "",
    village: "",
    address: "",
    phoneNumber: "",
    email: "",
    website: "",
  });
  const [learners, setLearners] = useState([]);
  const [streams, setStreams] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [previousPositions, setPreviousPositions] = useState({});
  const [includeHeader, setIncludeHeader] = useState(false);

  // NEW STATE VARIABLES - ADD THESE
  const [examSelectionOpen, setExamSelectionOpen] = useState(false);
  const [selectedPreviousExams, setSelectedPreviousExams] = useState([]);
  const [isLoadingPreviousPositions, setIsLoadingPreviousPositions] =
    useState(false);

  const year = 2025;

  useEffect(() => {
    const fetchSchoolDetails = async () => {
      try {
        const response = await axios.get(
          "https://ed-9ny1.onrender.com/api/schools/profile",
          { params: { schoolId } }
        );
        setSchoolDetails({
          schoolName: response.data.schoolName || "Unknown School",
          schoolCode: response.data.schoolCode || "Unknown Code",
          county: response.data.county || "Unknown County",
          subcounty: response.data.subcounty || "Unknown Subcounty",
          location: response.data.location || "Unknown Location",
          village: response.data.village || "Unknown Village",
          address: response.data.address || "Unknown Address",
          phoneNumber: response.data.phoneNumber || "Unknown Contact",
          email: response.data.email || "Unknown Email",
          website: response.data.website || "Not Specified",
        });
      } catch (error) {
        console.error("Error fetching school details:", error);
      }
    };

    const fetchLearners = async () => {
      try {
        const response = await axios.get(
          "https://ed-9ny1.onrender.com/api/schools/learners",
          { params: { schoolId } }
        );
        const gradeLearners = response.data.filter(
          (learner) => learner.class === grade
        );
        setLearners(gradeLearners);
        const gradeStreams = [
          ...new Set(
            gradeLearners.map((learner) => learner.stream).filter(Boolean)
          ),
        ].sort();
        setStreams(gradeStreams);
      } catch (error) {
        console.error("Error fetching learners:", error);
      }
    };

    fetchSchoolDetails();
    fetchLearners().finally(() => setIsLoading(false));
  }, [schoolId, grade]);

  // NEW: Function to fetch positions for selected exams - ADD THIS FUNCTION
  const fetchSelectedExamPositions = async (selectedExams) => {
    if (!selectedExams || selectedExams.length === 0) {
      setPreviousPositions({});
      return;
    }

    try {
      setIsLoadingPreviousPositions(true);
      console.log("Fetching positions for selected exams:", selectedExams);

      const response = await axios.post(
        `https://ed-9ny1.onrender.com/api/schools/${schoolId}/performance/selected-previous-positions`,
        {
          class: grade,
          selectedExams: selectedExams.map((exam) => ({
            term: exam.term,
            examType: exam.examType,
            examName: exam.examName || null,
          })),
        }
      );

      console.log("Selected exam positions response:", response.data);
      setPreviousPositions(response.data.previousPositions || {});
    } catch (error) {
      console.error("Error fetching selected exam positions:", error);
      setPreviousPositions({});
    } finally {
      setIsLoadingPreviousPositions(false);
    }
  };

  // NEW: Handle exam selection confirmation - ADD THIS FUNCTION
  const handleExamSelectionConfirm = (selectedExams) => {
    setSelectedPreviousExams(selectedExams);
    fetchSelectedExamPositions(selectedExams);
  };

  // Get previous exam keys from selected exams - UPDATE THIS FUNCTION
  const previousExamKeys = selectedPreviousExams.map(
    (exam) => `${exam.term}-${exam.examType}-${exam.examName || ""}`
  );

  const calculatePositions = (learners) => {
    let currentPosition = 1;
    let previousTotal = null;
    let samePositionCount = 0;

    return learners.map((learner, index) => {
      if (index === 0) {
        previousTotal = learner.total;
        return { ...learner, position: currentPosition };
      }
      if (learner.total === previousTotal) {
        samePositionCount++;
        return { ...learner, position: currentPosition };
      } else {
        currentPosition += samePositionCount + 1;
        samePositionCount = 0;
        previousTotal = learner.total;
        return { ...learner, position: currentPosition };
      }
    });
  };

  const processedLearners = calculatePositions(
    (data?.learners || [])
      .map((learner) => {
        const marks = subjects.reduce((acc, subject) => {
          // For term summary, we already have averages
          acc[subject] = learner.marks[subject] || 0;
          return acc;
        }, {});

        // Always compute total as sum of marks (for term summary, this will be sum of averages)
        const total = Object.values(marks).reduce((sum, mark) => sum + mark, 0);

        // Compute mean based on valid marks
        const validMarks = Object.values(marks).filter(
          (mark) => mark > 0
        );
        const mean = validMarks.length > 0
          ? Number((total / validMarks.length).toFixed(2))
          : 0;

        const learnerData = learners.find((l) => l._id === learner.learnerId);
        const stream = learnerData?.stream || learner.stream || "No Stream";
        const learnerPreviousPositions =
          previousPositions[learner.learnerId] || {};

        return {
          ...learner,
          marks,
          total,
          mean,
          stream,
          previousPositions: learnerPreviousPositions,
        };
      })
      .sort((a, b) => b.total - a.total)
  );

  const learnersByStream = streams.reduce((acc, stream) => {
    acc[stream] = calculatePositions(
      processedLearners
        .filter((learner) => learner.stream === stream)
        .sort((a, b) => b.total - a.total)
    );
    return acc;
  }, {});
  learnersByStream["General"] = processedLearners;

  const streamAverages = Object.entries(learnersByStream)
    .map(([stream, learners]) => ({
      stream,
      average:
        learners.length > 0
          ? Number(
              (
                learners.reduce((sum, learner) => sum + learner.total, 0) /
                learners.length
              ).toFixed(2)
            )
          : 0,
      count: learners.length,
    }))
    .sort((a, b) => b.average - a.average);

  const subjectAverages = subjects.map((subject, index) => {
    const marks = processedLearners
      .map((learner) => learner.marks[subject] || 0)
      .filter((mark) => mark > 0);
    const average =
      marks.length > 0
        ? Number(
            (marks.reduce((sum, mark) => sum + mark, 0) / marks.length).toFixed(
              2
            )
          )
        : 0;
    return {
      subject: displaySubjects[index],
      dataSubject: subject,
      average,
      count: marks.length,
    };
  });

  const subjectAveragesByStream = streams.reduce((acc, stream) => {
    const streamLearners = learnersByStream[stream];
    acc[stream] = subjects.map((subject, index) => {
      const marks = streamLearners
        .map((learner) => learner.marks[subject] || 0)
        .filter((mark) => mark > 0);
      const average =
        marks.length > 0
          ? Number(
              (
                marks.reduce((sum, mark) => sum + mark, 0) / marks.length
              ).toFixed(2)
            )
          : 0;
      return {
        subject: displaySubjects[index],
        dataSubject: subject,
        average,
        count: marks.length,
      };
    });
    return acc;
  }, {});

  const topPerformers = processedLearners.slice(0, 5);

  const topStudentsBySubject = subjects.reduce((acc, subject, index) => {
    const sortedLearners = processedLearners
      .filter((learner) => learner.marks[subject] > 0)
      .sort((a, b) => b.marks[subject] - a.marks[subject]);
    const topScores = [
      ...new Set(sortedLearners.map((l) => l.marks[subject])),
    ].slice(0, topN);
    acc[displaySubjects[index]] = sortedLearners
      .filter((learner) => topScores.includes(learner.marks[subject]))
      .map((learner) => ({
        name: learner.learnerName,
        score: learner.marks[subject],
        stream: learner.stream,
        learnerId: learner.learnerId,
      }));
    return acc;
  }, {});

  const pieData = {
    labels: subjectAverages.map((item) => getShortSubjectName(item.subject)),
    datasets: [
      {
        data: subjectAverages.map((item) => item.average),
        backgroundColor: subjectAverages.map(
          (_, index) =>
            `hsl(${(index * 360) / (subjects.length || 1)}, 65%, 55%)`
        ),
      },
    ],
  };

  const barData = {
    labels: displaySubjects.map((sub) => getShortSubjectName(sub)),
    datasets: [
      {
        label: "Average (%)",
        data: subjectAverages.map((item) => item.average || 0),
        backgroundColor: "#3182CE",
      },
    ],
  };

  const prepareSubjectComparisonData = (displaySubject) => {
    const subjectIndex = displaySubjects.indexOf(displaySubject);
    const dataSubject = subjects[subjectIndex];
    return {
      labels: streams,
      datasets: [
        {
          data: streams.map(
            (stream) =>
              subjectAveragesByStream[stream]?.find(
                (item) => item.dataSubject === dataSubject
              )?.average || 0
          ),
          backgroundColor: streams.map(
            (_, index) =>
              `hsl(${(index * 360) / (streams.length || 1)}, 65%, 55%)`
          ),
        },
      ],
    };
  };

  const calculateMeanRow = (learners) => {
    const meanData = {
      learnerName: "Mean",
      marks: {},
      total: 0,
      displayMarks: {},
      previousPosition: "-",
    };
    subjects.forEach((subject, index) => {
      const subjectMarks = learners
        .map((learner) => learner.marks[subject] || 0)
        .filter((mark) => mark > 0);
      const sum = subjectMarks.reduce((a, b) => a + b, 0);
      meanData.marks[subject] =
        Number((sum / (subjectMarks.length || 1)).toFixed(2)) || 0;
      meanData.displayMarks[displaySubjects[index]] = meanData.marks[subject];
    });
    const totals = learners.map((learner) => learner.total);
    meanData.total =
      Number(
        (totals.reduce((a, b) => a + b, 0) / (learners.length || 1)).toFixed(2)
      ) || 0;
    return meanData;
  };

  const generateCSVContent = (learners, stream, type) => {
    const toUpper = (val) => typeof val === 'string' ? val.toUpperCase() : val;

    const sections = [
      [`School: ${toUpper(schoolDetails.schoolName)}`],
      [`Email: ${toUpper(schoolDetails.email)}`],
      [`Year: ${year}`],
      [""],
      [`${toUpper(grade)} - Term ${term} - ${toUpper(getExamDisplayTitle(examType, examName))}`],
      [""],
    ];

    if (type === "general" && streams.length > 0) {
      sections.push(["Subject Analysis by Stream"]);
      sections.push([
        "Stream",
        ...displaySubjects.map((sub) => toUpper(getShortSubjectName(sub))),
        "Total",
        "Average",
      ]);
      streams.sort().forEach((stream) => {
        const averages = subjectAveragesByStream[stream].map(
          (item) => item.average || 0
        );
        const streamTotal = averages.reduce((sum, v) => sum + v, 0);
        const streamAvg =
          subjects.length > 0 ? streamTotal / subjects.length : 0;
        sections.push([
          toUpper(stream),
          ...averages.map(toUpper),
          toUpper(streamTotal.toFixed(2)),
          toUpper(streamAvg.toFixed(2)),
        ]);
      });
      const overallAverages = subjectAverages.map((item) => item.average || 0);
      const overallTotal = overallAverages.reduce((sum, v) => sum + v, 0);
      const overallAvg =
        subjects.length > 0 ? overallTotal / subjects.length : 0;
      sections.push([
        "Overall",
        ...overallAverages.map((v) => toUpper(v.toFixed(2))),
        toUpper(overallTotal.toFixed(2)),
        toUpper(overallAvg.toFixed(2)),
      ]);
      sections.push([""]);
    }

    sections.push(["Top Performers by Subject"]);
    sections.push(["Student", "Subject", "Score (%)"]);
    Object.entries(topStudentsBySubject).forEach(([subject, students]) => {
      students.forEach((student) => {
        sections.push([
          toUpper(`${student.name} (${student.stream || "No Stream"})`),
          toUpper(getShortSubjectName(subject)),
          toUpper(student.score),
        ]);
      });
    });
    sections.push([""]);

    sections.push([
      type === "general"
        ? "Detailed Results - All Students"
        : `Detailed Results - Stream ${toUpper(stream)}`,
    ]);

    // UPDATED: Use single column for previous positions
    const headers = [
      "No.",
      "Student",
      ...displaySubjects.map((sub) => toUpper(getShortSubjectName(sub))),
      "Total",
      "Position",
      "Prev. Positions",
      ...(type === "general" ? ["Stream"] : []),
    ].map(toUpper);

    const rows = learners.map((learner, index) => [
      index + 1,
      toUpper(`${learner.learnerName}${
        type === "general" && learner.stream ? ` (${toUpper(learner.stream)})` : ""
      }`),
      ...subjects.map((subject) => toUpper(learner.marks[subject] || "-")),
      toUpper(learner.total),
      toUpper(learner.position),
      toUpper(previousExamKeys.map((key) => learner.previousPositions[key] ?? "-").join(",")),
      ...(type === "general" ? [toUpper(learner.stream || "No Stream")] : []),
    ]);

    const meanRow = calculateMeanRow(learners);
    const meanRowData = [
      "-",
      "Mean",
      ...subjects.map((subject) => toUpper(`${meanRow.marks[subject]}`)),
      toUpper(meanRow.total),
      "-",
      "-",
      ...(type === "general" ? ["-"] : []),
    ].map(toUpper);

    sections.push(headers);
    sections.push(...rows);
    sections.push(meanRowData);

    return sections.map((row) => row.map(toUpper).join(",")).join("\n");
  };

  // ADD THIS NEW FUNCTION FOR EXAM SELECTION BUTTON
  const renderExamSelectionButton = () => (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 2,
        mb: 2,
        p: 2,
        bgcolor: "#f5f5f5",
        borderRadius: 1,
      }}
    >
      <Typography variant="h6" sx={{ flexGrow: 1 }}>
        Previous Exam Positions
      </Typography>

      {selectedPreviousExams.length > 0 && (
        <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
          {selectedPreviousExams.map((exam, index) => (
            <Chip
              key={exam._id || index}
              label={`${index + 1}. ${getExamDisplayTitle(
                exam.examType,
                exam.examName
              )}`}
              size="small"
              variant="outlined"
            />
          ))}
        </Box>
      )}

      <Button
        variant="outlined"
        startIcon={<Settings />}
        onClick={() => setExamSelectionOpen(true)}
        disabled={isLoadingPreviousPositions}
      >
        {isLoadingPreviousPositions ? (
          <CircularProgress size={20} />
        ) : selectedPreviousExams.length > 0 ? (
          `Configure (${selectedPreviousExams.length} selected)`
        ) : (
          "Select Previous Exams"
        )}
      </Button>
    </Box>
  );

  const generateDocxContent = (learners, stream, type) => {
    const toUpper = (val) => typeof val === 'string' ? val.toUpperCase() : val;

    const headerContent = includeHeader
      ? `
      <div style="font-family: Arial, sans-serif; text-align: center; margin-bottom: 20px; border-bottom: 2px solid #3182CE; padding-bottom: 10px;">
        <h1 style="font-size: 26px; margin: 5px 0; color: #2D3748;">${toUpper(
          schoolDetails.schoolName
        )}</h1>
        <p style="font-size: 16px; margin: 5px 0; color: #4A5568;">Email: ${toUpper(
          schoolDetails.email
        )}</p>
        <p style="font-size: 16px; margin: 5px 0; color: #4A5568;">Year: ${year}</p>
        <h2 style="font-size: 22px; margin: 5px 0; color: #3182CE;">${toUpper(grade)} - Term ${term} - ${toUpper(getExamDisplayTitle(
          examType,
          examName
        ))} - ${type === "general" ? "General Results" : `Stream ${toUpper(stream)}`}</h2>
      </div>
    `
      : "";

    let content = `
      <div style="font-family: Arial, sans-serif; padding: 30px; line-height: 1.6;">
        ${!includeHeader ? headerContent : ""}
    `;

    if (type === "general" && streams.length > 0) {
      content += `
        <h3 style="font-size: 20px; color: #2D3748; margin-bottom: 15px; border-bottom: 1px solid #E2E8F0;">${toUpper("Subject Analysis by Stream")}</h3>
        <table style="width: 100%; border-collapse: collapse; margin-top: 12px; border: 1px solid #E2E8F0; page-break-inside: auto;">
          <thead>
            <tr style="background-color: #3182CE; color: #FFFFFF;">
              <th style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${toUpper("Stream")}</th>
              ${displaySubjects
                .map(
                  (subject) =>
                    `<th style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${toUpper(getShortSubjectName(
                      subject
                    ))}</th>`
                )
                .join("")}
              <th style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${toUpper("Total")}</th>
              <th style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${toUpper("Average")}</th>
            </tr>
          </thead>
          <tbody>
            ${streams
              .sort()
              .map((stream) => {
                const averages = subjectAveragesByStream[stream].map(
                  (item) => item.average || 0
                );
                const streamTotal = averages.reduce((sum, v) => sum + v, 0);
                const streamAvg =
                  subjects.length > 0 ? streamTotal / subjects.length : 0;
                return `
                <tr>
                  <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${toUpper(stream)}</td>
                  ${averages
                    .map(
                      (avg) =>
                        `<td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${toUpper(avg.toFixed(
                          2
                        ))}</td>`
                    )
                    .join("")}
                  <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0; font-weight: bold;">${toUpper(streamTotal.toFixed(
                    2
                  ))}</td>
                  <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0; font-weight: bold;">${toUpper(streamAvg.toFixed(
                    2
                  ))}</td>
                </tr>
              `;
              })
              .join("")}
            ${(() => {
              const overallAverages = subjectAverages.map(
                (item) => item.average || 0
              );
              const overallTotal = overallAverages.reduce(
                (sum, v) => sum + v,
                0
              );
              const overallAvg =
                subjects.length > 0 ? overallTotal / subjects.length : 0;
              return `
                <tr style="background-color: #F0F9FF; font-weight: bold;">
                  <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${toUpper("Overall")}</td>
                  ${overallAverages
                    .map(
                      (avg) =>
                        `<td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${toUpper(avg.toFixed(
                          2
                        ))}</td>`
                    )
                    .join("")}
                  <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${toUpper(overallTotal.toFixed(
                    2
                  ))}</td>
                  <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${toUpper(overallAvg.toFixed(
                    2
                  ))}</td>
                </tr>
              `;
            })()}
          </tbody>
        </table>
      `;
    }

    content += `
        <h3 style="font-size: 20px; color: #2D3748; margin: 20px 0 15px; border-bottom: 1px solid #E2E8F0;">${toUpper("Top Performers by Subject")}</h3>
        <table style="width: 100%; border-collapse: collapse; margin-top: 12px; border: 1px solid #E2E8F0; page-break-inside: auto;">
          <thead>
            <tr style="background-color: #3182CE; color: #FFFFFF;">
              <th style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${toUpper("Student")}</th>
              <th style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${toUpper("Subject")}</th>
              <th style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${toUpper("Score (%")}</th>
            </tr>
          </thead>
          <tbody>
            ${Object.entries(topStudentsBySubject)
              .flatMap(([subject, students]) =>
                students.map(
                  (student) => `
                <tr>
                  <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${toUpper(
                    student.name
                  )} (${toUpper(student.stream || "No Stream")})</td>
                  <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${toUpper(getShortSubjectName(
                    subject
                  ))}</td>
                  <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${toUpper(
                    student.score
                  )}</td>
                </tr>
              `
                )
              )
              .join("")}
          </tbody>
        </table>

        <h3 style="font-size: 20px; color: #2D3748; margin: 20px 0 15px; border-bottom: 1px solid #E2E8F0;">${toUpper("Detailed Results")}</h3>
        <table style="width: 100%; border-collapse: collapse; margin-top: 12px; border: 1px solid #E2E8F0; page-break-inside: auto;">
          <thead>
            <tr style="background-color: #3182CE; color: #FFFFFF;">
              <th style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${toUpper("No.")}</th>
              <th style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${toUpper("Student")}</th>
              ${displaySubjects
                .map(
                  (subject) =>
                    `<th style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${toUpper(getShortSubjectName(
                      subject
                    ))}</th>`
                )
                .join("")}
              <th style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${toUpper("Total")}</th>
              <th style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${toUpper("Position")}</th>
              <th style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${toUpper("Prev. Positions")}</th>
              ${
                type === "general"
                  ? `<th style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${toUpper("Stream")}</th>`
                  : ""
              }
            </tr>
          </thead>
          <tbody>
            ${learners
              .map(
                (learner, index) => `
              <tr style="page-break-inside: avoid;">
                <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${toUpper(
                  index + 1
                )}</td>
                <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${toUpper(
                  learner.learnerName
                )}${
                  type === "general" && learner.stream
                    ? ` (${toUpper(learner.stream)})`
                    : ""
                }</td>
                ${subjects
                  .map(
                    (subject) =>
                      `<td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${toUpper(
                        learner.marks[subject] || "-"
                      )}</td>`
                  )
                  .join("")}
                <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0; font-weight: bold;">${toUpper(
                  learner.total
                )}</td>
                <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${toUpper(
                  learner.position
                )}</td>
                <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${toUpper(previousExamKeys
                  .map((key) => learner.previousPositions[key] ?? "-")
                  .join(","))}</td>
                ${
                  type === "general"
                    ? `<td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${toUpper(
                        learner.stream || "No Stream"
                      )}</td>`
                    : ""
                }
              </tr>
            `
              )
              .join("")}
            <tr style="background-color: #F0F9FF; font-weight: bold; page-break-inside: avoid;">
              <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${toUpper("-")}</td>
              <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${toUpper("Mean")}</td>
              ${displaySubjects
                .map(
                  (subject) =>
                    `<td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${toUpper(
                      calculateMeanRow(learners).displayMarks[subject]
                    )}</td>`
                )
                .join("")}
              <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0; font-weight: bold;">${toUpper(
                calculateMeanRow(learners).total
              )}</td>
              <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${toUpper("-")}</td>
              <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${toUpper("-")}</td>
              ${
                type === "general"
                  ? `<td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${toUpper("-")}</td>`
                  : ""
              }
            </tr>
          </tbody>
        </table>
      </div>
    `;
    return content;
  };

  const createDocument = async (stream, type, format) => {
    try {
      const learnersToUse =
        type === "general"
          ? learnersByStream["General"]
          : learnersByStream[stream];
      const fileNameBase = `Performance_${grade}_Term${term}_${getExamDisplayTitle(
        examType,
        examName
      ).replace(/\s+/g, "_")}_${
        type === "general" ? "General" : `Stream_${stream}`
      }`;
      setIsGenerating((prev) => ({
        ...prev,
        [type === "general" ? "general" : "streams"]: {
          ...prev.streams,
          [stream]: true,
        },
      }));

      if (format === "pdf") {
        const toUpper = (val) => typeof val === 'string' ? val.toUpperCase() : val;

        const doc = new jsPDF();
        doc.setFontSize(16);
        doc.text(toUpper(schoolDetails.schoolName), 105, 20, { align: "center" });
        doc.setFontSize(12);
        doc.text(`Email: ${toUpper(schoolDetails.email)}`, 105, 30, { align: "center" });
        doc.text(`Year: ${year}`, 105, 40, { align: "center" });
        doc.text(
          `${toUpper(grade)} - Term ${term} - ${toUpper(getExamDisplayTitle(
            examType,
            examName
          ))} - ${type === "general" ? toUpper("General Results") : `${toUpper("Stream")} ${toUpper(stream)}`}`,
          105,
          50,
          { align: "center" }
        );

        let startY = 60;

        if (type === "general" && streams.length > 0) {
          doc.text(toUpper("Subject Analysis by Stream"), 20, startY);
          autoTable(doc, {
            startY: startY + 5,
            head: [
              [
                toUpper("Stream"),
                ...displaySubjects.map((sub) => toUpper(getShortSubjectName(sub))),
                toUpper("Total"),
                toUpper("Average"),
              ],
            ],
            body: [
              ...streams.sort().map((stream) => {
                const averages = subjectAveragesByStream[stream].map(
                  (item) => item.average || 0
                );
                const streamTotal = averages.reduce((sum, v) => sum + v, 0);
                const streamAvg =
                  subjects.length > 0 ? streamTotal / subjects.length : 0;
                return [
                  toUpper(stream),
                  ...averages.map(toUpper),
                  toUpper(streamTotal.toFixed(2)),
                  toUpper(streamAvg.toFixed(2)),
                ];
              }),
              (() => {
                const overallAverages = subjectAverages.map(
                  (item) => item.average || 0
                );
                const overallTotal = overallAverages.reduce(
                  (sum, v) => sum + v,
                  0
                );
                const overallAvg =
                  subjects.length > 0 ? overallTotal / subjects.length : 0;
                return [
                  toUpper("Overall"),
                  ...overallAverages.map(toUpper),
                  toUpper(overallTotal.toFixed(2)),
                  toUpper(overallAvg.toFixed(2)),
                ];
              })(),
            ],
            styles: { lineColor: [226, 232, 240], lineWidth: 0.1 },
            headStyles: {
              fillColor: [49, 130, 206],
              textColor: [255, 255, 255],
            },
            alternateRowStyles: { fillColor: [240, 249, 255] },
          });
          startY = doc.lastAutoTable.finalY + 10;
        }

        doc.text(toUpper("Top Performers by Subject"), 20, startY);
        autoTable(doc, {
          startY: startY + 5,
          head: [[toUpper("Student"), toUpper("Subject"), toUpper("Score (%")]],
          body: Object.entries(topStudentsBySubject).flatMap(
            ([subject, students]) =>
              students.map((student) => [
                toUpper(`${student.name} (${student.stream || "No Stream"})`),
                toUpper(getShortSubjectName(subject)),
                toUpper(student.score),
              ])
          ),
          styles: { lineColor: [226, 232, 240], lineWidth: 0.1 },
          headStyles: { fillColor: [49, 130, 206], textColor: [255, 255, 255] },
          alternateRowStyles: { fillColor: [240, 249, 255] },
        });
        startY = doc.lastAutoTable.finalY + 10;

        doc.text(toUpper("Detailed Results"), 20, startY);
        autoTable(doc, {
          startY: startY + 5,
          head: [
            [
              toUpper("No."),
              toUpper("Student"),
              ...displaySubjects.map((sub) => toUpper(getShortSubjectName(sub))),
              toUpper("Total"),
              toUpper("Position"),
              toUpper("Prev. Positions"),
              ...(type === "general" ? [toUpper("Stream")] : []),
            ],
          ],
          body: [
            ...learnersToUse.map((learner, index) => [
              index + 1,
              toUpper(`${learner.learnerName}${
                type === "general" && learner.stream
                  ? ` (${toUpper(learner.stream)})`
                  : ""
              }`),
              ...subjects.map((subject) => toUpper(learner.marks[subject] || "-")),
              toUpper(learner.total),
              toUpper(learner.position),
              toUpper(previousExamKeys
                .map((key) => learner.previousPositions[key] ?? "-")
                .join(",")),
              ...(type === "general" ? [toUpper(learner.stream || "No Stream")] : []),
            ]),
            [
              "-",
              toUpper("Mean"),
              ...subjects.map(
                (subject) => toUpper(calculateMeanRow(learnersToUse).marks[subject])
              ),
              toUpper(calculateMeanRow(learnersToUse).total),
              "-",
              "-",
              ...(type === "general" ? ["-"] : []),
            ],
          ],
          styles: { lineColor: [226, 232, 240], lineWidth: 0.1 },
          headStyles: { fillColor: [49, 130, 206], textColor: [255, 255, 255] },
          alternateRowStyles: { fillColor: [240, 249, 255] },
        });
        doc.save(`${fileNameBase}.pdf`);
      } else if (format === "docx") {
        const htmlContent = generateDocxContent(learnersToUse, stream, type);
        const docx = htmlDocx.asBlob(htmlContent);
        const url = URL.createObjectURL(docx);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${fileNameBase}.docx`;
        a.click();
        URL.revokeObjectURL(url);
      } else if (format === "csv") {
        const csvContent = generateCSVContent(learnersToUse, stream, type);
        const blob = new Blob([csvContent], {
          type: "text/csv;charset=utf-8;",
        });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${fileNameBase}.csv`;
        a.click();
        URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.error(`Error generating ${format} report:`, error);
      alert(`Failed to generate ${format} report. Please try again.`);
    } finally {
      setIsGenerating((prev) => ({
        ...prev,
        [type === "general" ? "general" : "streams"]: {
          ...prev.streams,
          [stream]: false,
        },
      }));
    }
  };

  const createFullPDF = async (format) => {
    try {
      setIsGenerating((prev) => ({ ...prev, general: true }));
      const fileName = `Performance_${grade}_Term${term}_${getExamDisplayTitle(
        examType,
        examName
      ).replace(/\s+/g, "_")}`;
      const generalMeanRow = calculateMeanRow(learnersByStream["General"]);
      const streamMeanRows = streams.reduce((acc, stream) => {
        acc[stream] = calculateMeanRow(learnersByStream[stream]);
        return acc;
      }, {});

      if (format === "pdf") {
        const toUpper = (val) => typeof val === 'string' ? val.toUpperCase() : val;

        const doc = new jsPDF();
        doc.setFontSize(16);
        doc.text(toUpper(schoolDetails.schoolName), 105, 20, { align: "center" });
        doc.setFontSize(12);
        doc.text(`Email: ${toUpper(schoolDetails.email)}`, 105, 30, { align: "center" });
        doc.text(`Year: ${year}`, 105, 40, { align: "center" });
        doc.text(
          `${toUpper(grade)} - Term ${term} - ${toUpper(getExamDisplayTitle(
            examType,
            examName
          ))}`,
          105,
          50,
          { align: "center" }
        );

        let startY = 60;

        if (streams.length > 0) {
          doc.text(toUpper("Subject Analysis by Stream"), 20, startY);
          autoTable(doc, {
            startY: startY + 5,
            head: [
              [
                toUpper("Stream"),
                ...displaySubjects.map((sub) => toUpper(getShortSubjectName(sub))),
                toUpper("Total"),
                toUpper("Average"),
              ],
            ],
            body: [
              ...streams.sort().map((stream) => {
                const averages = subjectAveragesByStream[stream].map(
                  (item) => item.average || 0
                );
                const streamTotal = averages.reduce((sum, v) => sum + v, 0);
                const streamAvg =
                  subjects.length > 0 ? streamTotal / subjects.length : 0;
                return [
                  toUpper(stream),
                  ...averages.map(toUpper),
                  toUpper(streamTotal.toFixed(2)),
                  toUpper(streamAvg.toFixed(2)),
                ];
              }),
              (() => {
                const overallAverages = subjectAverages.map(
                  (item) => item.average || 0
                );
                const overallTotal = overallAverages.reduce(
                  (sum, v) => sum + v,
                  0
                );
                const overallAvg =
                  subjects.length > 0 ? overallTotal / subjects.length : 0;
                return [
                  toUpper("Overall"),
                  ...overallAverages.map(toUpper),
                  toUpper(overallTotal.toFixed(2)),
                  toUpper(overallAvg.toFixed(2)),
                ];
              })(),
            ],
            styles: { lineColor: [226, 232, 240], lineWidth: 0.1 },
            headStyles: {
              fillColor: [49, 130, 206],
              textColor: [255, 255, 255],
            },
            alternateRowStyles: { fillColor: [240, 249, 255] },
          });
          startY = doc.lastAutoTable.finalY + 10;
        }

        doc.text(toUpper("Top Performers by Subject"), 20, startY);
        autoTable(doc, {
          startY: startY + 5,
          head: [[toUpper("Student"), toUpper("Subject"), toUpper("Score (%")]],
          body: Object.entries(topStudentsBySubject).flatMap(
            ([subject, students]) =>
              students.map((student) => [
                toUpper(`${student.name} (${student.stream || "No Stream"})`),
                toUpper(getShortSubjectName(subject)),
                toUpper(student.score),
              ])
          ),
          styles: { lineColor: [226, 232, 240], lineWidth: 0.1 },
          headStyles: { fillColor: [49, 130, 206], textColor: [255, 255, 255] },
          alternateRowStyles: { fillColor: [240, 249, 255] },
        });
        startY = doc.lastAutoTable.finalY + 10;

        doc.text(toUpper("Detailed Results - All Students"), 20, startY);
        autoTable(doc, {
          startY: startY + 5,
          head: [
            [
              toUpper("No."),
              toUpper("Student"),
              ...displaySubjects.map((sub) => toUpper(getShortSubjectName(sub))),
              toUpper("Total"),
              toUpper("Position"),
              toUpper("Prev. Positions"),
              toUpper("Stream"),
            ],
          ],
          body: [
            ...learnersByStream["General"].map((learner, index) => [
              index + 1,
              toUpper(`${learner.learnerName}${
                learner.stream ? ` (${toUpper(learner.stream)})` : ""
              }`),
              ...subjects.map((subject) => toUpper(learner.marks[subject] || "-")),
              toUpper(learner.total),
              toUpper(learner.position),
              toUpper(previousExamKeys
                .map((key) => learner.previousPositions[key] ?? "-")
                .join(",")),
              toUpper(learner.stream || "No Stream"),
            ]),
            [
              "-",
              toUpper("Mean"),
              ...subjects.map((subject) => toUpper(generalMeanRow.marks[subject])),
              toUpper(generalMeanRow.total),
              "-",
              "-",
              "-",
            ],
          ],
          styles: { lineColor: [226, 232, 240], lineWidth: 0.1 },
          headStyles: { fillColor: [49, 130, 206], textColor: [255, 255, 255] },
          alternateRowStyles: { fillColor: [240, 249, 255] },
        });

        streams.sort().forEach((stream) => {
          doc.addPage();
          doc.text(toUpper(`Detailed Results - Stream ${stream}`), 20, 20);
          autoTable(doc, {
            startY: 25,
            head: [
              [
                toUpper("No."),
                toUpper("Student"),
                ...displaySubjects.map((sub) => toUpper(getShortSubjectName(sub))),
                toUpper("Total"),
                toUpper("Position"),
                toUpper("Prev. Positions"),
              ],
            ],
            body: [
              ...learnersByStream[stream].map((learner, index) => [
                index + 1,
                toUpper(learner.learnerName),
                ...subjects.map((subject) => toUpper(learner.marks[subject] || "-")),
                toUpper(learner.total),
                toUpper(learner.position),
                toUpper(previousExamKeys
                  .map((key) => learner.previousPositions[key] ?? "-")
                  .join(",")),
              ]),
              [
                "-",
                toUpper("Mean"),
                ...subjects.map(
                  (subject) => toUpper(streamMeanRows[stream].marks[subject])
                ),
                toUpper(streamMeanRows[stream].total),
                "-",
                "-",
              ],
            ],
            styles: { lineColor: [226, 232, 240], lineWidth: 0.1 },
            headStyles: {
              fillColor: [49, 130, 206],
              textColor: [255, 255, 255],
            },
            alternateRowStyles: { fillColor: [240, 249, 255] },
          });
        });

        doc.save(`${fileName}_FullReport.pdf`);
      } else if (format === "docx") {
        const headerContent = includeHeader
          ? `
          <div style="font-family: Arial, sans-serif; text-align: center; margin-bottom: 20px; border-bottom: 2px solid #3182CE; padding-bottom: 10px;">
            <h1 style="font-size: 26px; margin: 5px 0; color: #2D3748;">${
              schoolDetails.schoolName
            }</h1>
            <p style="font-size: 16px; margin: 5px 0; color: #4A5568;">Email: ${
              schoolDetails.email
            }</p>
            <p style="font-size: 16px; margin: 5px 0; color: #4A5568;">Year: ${year}</p>
            <h2 style="font-size: 22px; margin: 5px 0; color: #3182CE;">${grade} - Term ${term} - ${getExamDisplayTitle(
              examType,
              examName
            )}</h2>
          </div>
        `
          : "";

        let htmlContent = `
          <div style="font-family: Arial, sans-serif; padding: 30px; line-height: 1.6;">
            ${!includeHeader ? headerContent : ""}
        `;

        if (streams.length > 0) {
          htmlContent += `
            <h3 style="font-size: 20px; color: #2D3748; margin-bottom: 15px; border-bottom: 1px solid #E2E8F0;">Subject Analysis by Stream</h3>
            <table style="width: 100%; border-collapse: collapse; margin-top: 12px; border: 1px solid #E2E8F0;">
              <thead>
                <tr style="background-color: #3182CE; color: #FFFFFF;">
                  <th style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">Stream</th>
                  ${displaySubjects
                    .map(
                      (subject) =>
                        `<th style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${getShortSubjectName(
                          subject
                        )}</th>`
                    )
                    .join("")}
                  <th style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">Total</th>
                  <th style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">Average</th>
                </tr>
              </thead>
              <tbody>
                ${streams
                  .sort()
                  .map((stream) => {
                    const averages = subjectAveragesByStream[stream].map(
                      (item) => item.average || 0
                    );
                    const streamTotal = averages.reduce((sum, v) => sum + v, 0);
                    const streamAvg =
                      subjects.length > 0 ? streamTotal / subjects.length : 0;
                    return `
                    <tr>
                      <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${stream}</td>
                      ${averages
                        .map(
                          (avg) =>
                            `<td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${avg.toFixed(
                              2
                            )}</td>`
                        )
                        .join("")}
                      <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0; font-weight: bold;">${streamTotal.toFixed(
                        2
                      )}</td>
                      <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0; font-weight: bold;">${streamAvg.toFixed(
                        2
                      )}</td>
                    </tr>
                  `;
                  })
                  .join("")}
                ${(() => {
                  const overallAverages = subjectAverages.map(
                    (item) => item.average || 0
                  );
                  const overallTotal = overallAverages.reduce(
                    (sum, v) => sum + v,
                    0
                  );
                  const overallAvg =
                    subjects.length > 0 ? overallTotal / subjects.length : 0;
                  return `
                    <tr style="background-color: #F0F9FF; font-weight: bold;">
                      <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">Overall</td>
                      ${overallAverages
                        .map(
                          (avg) =>
                            `<td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${avg.toFixed(
                              2
                            )}</td>`
                        )
                        .join("")}
                      <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${overallTotal.toFixed(
                        2
                      )}</td>
                      <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${overallAvg.toFixed(
                        2
                      )}</td>
                    </tr>
                  `;
                })()}
              </tbody>
            </table>
          `;
        }

        htmlContent += `
            <h3 style="font-size: 20px; color: #2D3748; margin: 20px 0 15px; border-bottom: 1px solid #E2E8F0;">Top Performers by Subject</h3>
            <table style="width: 100%; border-collapse: collapse; margin-top: 12px; border: 1px solid #E2E8F0;">
              <thead>
                <tr style="background-color: #3182CE; color: #FFFFFF;">
                  <th style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">Student</th>
                  <th style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">Subject</th>
                  <th style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">Score (%)</th>
                </tr>
              </thead>
              <tbody>
                ${Object.entries(topStudentsBySubject)
                  .flatMap(([subject, students]) =>
                    students.map(
                      (student) => `
                    <tr>
                      <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${
                        student.name
                      } (${student.stream || "No Stream"})</td>
                      <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${getShortSubjectName(
                        subject
                      )}</td>
                      <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${
                        student.score
                      }</td>
                    </tr>
                  `
                    )
                  )
                  .join("")}
              </tbody>
            </table>

            <h3 style="font-size: 20px; color: #2D3748; margin: 20px 0 15px; border-bottom: 1px solid #E2E8F0;">Detailed Results - All Students</h3>
            <table style="width: 100%; border-collapse: collapse; margin-top: 12px; border: 1px solid #E2E8F0;">
              <thead>
                <tr style="background-color: #3182CE; color: #FFFFFF;">
                  <th style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">No.</th>
                  <th style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">Student</th>
                  ${displaySubjects
                    .map(
                      (subject) =>
                        `<th style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${getShortSubjectName(
                          subject
                        )}</th>`
                    )
                    .join("")}
                  <th style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">Total</th>
                  <th style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">Position</th>
                  <th style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">Prev. Positions</th>
                  <th style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">Stream</th>
                </tr>
              </thead>
              <tbody>
                ${learnersByStream["General"]
                  .map(
                    (learner, index) => `
                  <tr>
                    <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${
                      index + 1
                    }</td>
                    <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${
                      learner.learnerName
                    }${learner.stream ? ` (${learner.stream})` : ""}</td>
                    ${subjects
                      .map(
                        (subject) =>
                          `<td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${
                            learner.marks[subject] || "-"
                          }</td>`
                      )
                      .join("")}
                    <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0; font-weight: bold;">${
                      learner.total
                    }</td>
                    <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${
                      learner.position
                    }</td>
                    <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${previousExamKeys
                      .map((key) => learner.previousPositions[key] ?? "-")
                      .join(",")}</td>
                    <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${
                      learner.stream || "No Stream"
                    }</td>
                  </tr>
                `
                  )
                  .join("")}
                <tr style="background-color: #F0F9FF; font-weight: bold;">
                  <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">-</td>
                  <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">Mean</td>
                  ${displaySubjects
                    .map(
                      (subject) =>
                        `<td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${generalMeanRow.displayMarks[subject]}</td>`
                    )
                    .join("")}
                  <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0; font-weight: bold;">${
                    generalMeanRow.total
                  }</td>
                  <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">-</td>
                  <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">-</td>
                  <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">-</td>
                </tr>
              </tbody>
            </table>
            ${streams
              .sort()
              .map(
                (stream) => `
              <h3 style="font-size: 20px; color: #2D3748; margin: 20px 0 15px; border-bottom: 1px solid #E2E8F0;">Detailed Results - Stream ${stream}</h3>
              <table style="width: 100%; border-collapse: collapse; margin-top: 12px; border: 1px solid #E2E8F0;">
                <thead>
                  <tr style="background-color: #3182CE; color: #FFFFFF;">
                    <th style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">No.</th>
                    <th style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">Student</th>
                    ${displaySubjects
                      .map(
                        (subject) =>
                          `<th style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${getShortSubjectName(
                            subject
                          )}</th>`
                      )
                      .join("")}
                    <th style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">Total</th>
                    <th style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">Position</th>
                    <th style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">Prev. Positions</th>
                  </tr>
                </thead>
                <tbody>
                  ${learnersByStream[stream]
                    .map(
                      (learner, index) => `
                    <tr>
                      <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${
                        index + 1
                      }</td>
                      <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${
                        learner.learnerName
                      }</td>
                      ${subjects
                        .map(
                          (subject) =>
                            `<td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${
                              learner.marks[subject] || "-"
                            }</td>`
                        )
                        .join("")}
                      <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0; font-weight: bold;">${
                        learner.total
                      }</td>
                      <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${
                        learner.position
                      }</td>
                      <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${previousExamKeys
                        .map((key) => learner.previousPositions[key] ?? "-")
                        .join(",")}</td>
                    </tr>
                  `
                    )
                    .join("")}
                  <tr style="background-color: #F0F9FF; font-weight: bold;">
                    <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">-</td>
                    <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">Mean</td>
                    ${displaySubjects
                      .map(
                        (subject) =>
                          `<td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">${streamMeanRows[stream].displayMarks[subject]}</td>`
                      )
                      .join("")}
                    <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0; font-weight: bold;">${
                      streamMeanRows[stream].total
                    }</td>
                    <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">-</td>
                    <td style="padding: 12px; text-align: center; border: 1px solid #E2E8F0;">-</td>
                  </tr>
                </tbody>
              </table>
            `
              )
              .join("")}
          </div>
        `;
        const docx = htmlDocx.asBlob(htmlContent);
        const url = URL.createObjectURL(docx);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${fileName}_FullReport.docx`;
        a.click();
        URL.revokeObjectURL(url);
      } else if (format === "csv") {
        let csvContent = generateCSVContent(
          learnersByStream["General"],
          "General",
          "general"
        );
        // Append per stream detailed results for full CSV
        streams.sort().forEach((stream) => {
          csvContent +=
            "\n\n" +
            generateCSVContent(learnersByStream[stream], stream, "stream")
              .split("\n")
              .slice(6)
              .join("\n"); // Skip header for per stream
        });
        const blob = new Blob([csvContent], {
          type: "text/csv;charset=utf-8;",
        });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${fileName}_FullReport.csv`;
        a.click();
        URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.error(`Error generating ${format} report:`, error);
      alert(`Failed to generate ${format} report. Please try again.`);
    } finally {
      setIsGenerating((prev) => ({ ...prev, general: false }));
    }
  };

  if (isLoading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          flexDirection: "column",
        }}
      >
        <CircularProgress color="primary" />
        <Typography sx={{ mt: 2, color: "#4A5568" }}>
          Loading and Analyzing Performance Data...
        </Typography>
      </Box>
    );
  }

  return (
    <Container
      maxWidth="lg"
      sx={{ py: 4, bgcolor: "#f8f9fa", minHeight: "100vh", textTransform: "uppercase" }}
    >
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <Typography
          variant="h4"
          sx={{
            fontWeight: "bold",
            color: "#2c3e50",
            mb: 2,
            textAlign: "center",
          }}
        >
          {schoolDetails.schoolName} - {grade} - Term {term} -{" "}
          {getExamDisplayTitle(examType, examName)}
        </Typography>

        {/* ADD THE EXAM SELECTION BUTTON HERE */}
        {renderExamSelectionButton()}
        <Paper
          sx={{ p: 2, mb: 3, bgcolor: "#fff", border: "1px solid #E2E8F0" }}
        >
          <Typography variant="h6" sx={{ fontWeight: "600", color: "#2D3748" }}>
            {schoolDetails.schoolName}
          </Typography>
          <Typography sx={{ color: "#4A5568" }}>
            <strong>Exam:</strong> {getExamDisplayTitle(examType, examName)}
          </Typography>
          <Typography sx={{ color: "#4A5568" }}>
            <strong>School Code:</strong> {schoolDetails.schoolCode}
          </Typography>
          <Typography sx={{ color: "#4A5568" }}>
            <strong>Address:</strong>{" "}
            {[
              schoolDetails.village,
              schoolDetails.location,
              schoolDetails.subcounty,
              schoolDetails.county,
            ]
              .filter(Boolean)
              .join(", ")}
          </Typography>
          <Typography sx={{ color: "#4A5568" }}>
            <strong>Physical Address:</strong> {schoolDetails.address}
          </Typography>
          <Typography sx={{ color: "#4A5568" }}>
            <strong>Contact:</strong> {schoolDetails.phoneNumber}
          </Typography>
          <Typography sx={{ color: "#4A5568" }}>
            <strong>Email:</strong> {schoolDetails.email}
          </Typography>
          <Typography sx={{ color: "#4A5568" }}>
            <strong>Website:</strong> {schoolDetails.website}
          </Typography>
        </Paper>

        {/* Performance Overview */}
        <Paper
          sx={{ p: 3, mb: 3, bgcolor: "#fff", border: "1px solid #E2E8F0" }}
        >
          <Typography
            variant="h5"
            sx={{ fontWeight: "600", color: "#2D3748", mb: 2 }}
          >
            Performance Overview
          </Typography>
          {streams.length > 0 && (
            <Box
              sx={{
                mb: 3,
                p: 2,
                bgcolor: "#F7FAFC",
                borderRadius: 2,
                border: "1px solid #E2E8F0",
              }}
            >
              <Typography sx={{ fontWeight: "500", color: "#4A5568", mb: 2 }}>
                Stream Rankings
              </Typography>
              {streamAverages.map(({ stream, average, count }, index) => (
                <Box
                  key={stream}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    py: 1,
                    borderBottom: "1px solid #E2E8F0",
                  }}
                >
                  <Typography
                    sx={{ width: 60, fontWeight: "600", color: "#2D3748" }}
                  >
                    #{index + 1}
                  </Typography>
                  <Typography
                    sx={{ flex: 1, fontWeight: "500", color: "#2D3748" }}
                  >
                    {stream}
                  </Typography>
                  <Typography
                    sx={{
                      width: 70,
                      textAlign: "right",
                      fontWeight: "600",
                      color: "#3182CE",
                    }}
                  >
                    {average}%
                  </Typography>
                  <Typography
                    sx={{
                      width: 80,
                      textAlign: "right",
                      color: "#718096",
                      fontSize: "0.85rem",
                    }}
                  >
                    ({count} students)
                  </Typography>
                </Box>
              ))}
            </Box>
          )}
          <Box sx={{ mb: 3 }}>
            <Typography sx={{ fontWeight: "500", color: "#4A5568", mb: 2 }}>
              Subject Averages
            </Typography>
            <Box sx={{ maxWidth: 400, mx: "auto" }}>
              <Pie
                data={pieData}
                options={{ plugins: { legend: { position: "bottom" } } }}
              />
            </Box>
          </Box>
          <Box>
            <Typography sx={{ fontWeight: "500", color: "#4A5568", mb: 2 }}>
              Comparison of Averages
            </Typography>
            <Bar
              data={barData}
              options={{
                plugins: { legend: { display: false } },
                scales: {
                  y: {
                    beginAtZero: true,
                    title: { display: true, text: "Average (%)" },
                  },
                },
              }}
            />
          </Box>
        </Paper>

        {/* Subject Analysis by Stream */}
        {streams.length > 0 && (
          <Paper
            sx={{ p: 3, mb: 3, bgcolor: "#fff", border: "1px solid #E2E8F0" }}
          >
            <Typography
              variant="h5"
              sx={{ fontWeight: "600", color: "#2D3748", mb: 2 }}
            >
              Subject Analysis by Stream
            </Typography>
            {displaySubjects.map((subject) => (
              <Accordion
                key={subject}
                sx={{ mb: 2, bgcolor: "#fff", border: "1px solid #E2E8F0" }}
              >
                <AccordionSummary expandIcon={<ExpandMore />}>
                  <Typography sx={{ fontWeight: "600", color: "#2D3748" }}>
                    {getShortSubjectName(subject)}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Box sx={{ maxWidth: 400, mx: "auto", mb: 2 }}>
                    <Pie
                      data={prepareSubjectComparisonData(subject)}
                      options={{ plugins: { legend: { position: "bottom" } } }}
                    />
                  </Box>
                  <TableContainer>
                    <Table>
                      <TableHead>
                        <TableRow sx={{ bgcolor: "#E2E8F0" }}>
                          <TableCell
                            sx={{ fontWeight: "600", color: "#2D3748" }}
                          >
                            Stream
                          </TableCell>
                          <TableCell
                            sx={{ fontWeight: "600", color: "#2D3748" }}
                          >
                            Average
                          </TableCell>
                          <TableCell
                            sx={{ fontWeight: "600", color: "#2D3748" }}
                          >
                            Students
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {streams.sort().map((stream) => {
                          const streamAvg = subjectAveragesByStream[
                            stream
                          ].find((item) => item.subject === subject);
                          return (
                            <TableRow key={stream}>
                              <TableCell>{stream}</TableCell>
                              <TableCell>{streamAvg?.average || 0}</TableCell>
                              <TableCell>{streamAvg?.count || 0}</TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </AccordionDetails>
              </Accordion>
            ))}
          </Paper>
        )}

        {/* Top Performers */}
        <Paper
          sx={{ p: 3, mb: 3, bgcolor: "#fff", border: "1px solid #E2E8F0" }}
        >
          <Typography
            variant="h5"
            sx={{ fontWeight: "600", color: "#2D3748", mb: 2 }}
          >
            Top Performers
          </Typography>
          {topPerformers.map((performer) => (
            <Box
              key={performer.learnerId}
              sx={{
                p: 2,
                mb: 2,
                bgcolor: "#F7FAFC",
                borderRadius: 2,
                borderLeft: "4px solid #3182CE",
              }}
            >
              <Typography
                sx={{
                  fontWeight: "600",
                  color: "#2D3748",
                  cursor: "pointer",
                  "&:hover": { textDecoration: "underline" },
                }}
                onClick={() =>
                  navigate("/student-detailed-analysis", {
                    state: {
                      learnerId: performer.learnerId,
                      learnerName: performer.learnerName,
                      schoolId,
                      grade,
                    },
                  })
                }
              >
                {performer.learnerName}
              </Typography>
              <Typography sx={{ color: "#3182CE", fontWeight: "500" }}>
                Position: {performer.position} | Total: {performer.total} marks
                | Mean: {performer.mean}%
                {performer.stream && ` | Stream: ${performer.stream}`}
              </Typography>
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                {displaySubjects.map((displaySubject, index) => (
                  <Chip
                    key={displaySubject}
                    label={`${getShortSubjectName(displaySubject)}: ${
                      performer.marks[subjects[index]] || "N/A"
                    }`}
                    sx={{ bgcolor: "#e0e0e0", fontSize: "0.75rem" }}
                  />
                ))}
              </Box>
            </Box>
          ))}
        </Paper>

        {/* Top Students by Subject */}
        <Paper
          sx={{ p: 3, mb: 3, bgcolor: "#fff", border: "1px solid #E2E8F0" }}
        >
          <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
            <Typography
              variant="h5"
              sx={{ fontWeight: "600", color: "#2D3748", mr: 2 }}
            >
              Top Students by Subject
            </Typography>
            <FormControl sx={{ minWidth: 120 }}>
              <InputLabel>Top N</InputLabel>
              <Select
                value={topN}
                label="Top N"
                onChange={(e) => setTopN(e.target.value)}
              >
                <MenuItem value={1}>Top 1</MenuItem>
                <MenuItem value={2}>Top 2</MenuItem>
                <MenuItem value={3}>Top 3</MenuItem>
              </Select>
            </FormControl>
          </Box>
          {displaySubjects.map((subject) => (
            <Box
              key={subject}
              sx={{
                mb: 2,
                p: 2,
                bgcolor: "#fff",
                border: "1px solid #E2E8F0",
                borderRadius: 2,
              }}
            >
              <Typography sx={{ fontWeight: "600", color: "#2D3748", mb: 1 }}>
                {getShortSubjectName(subject)}
              </Typography>
              {topStudentsBySubject[subject].map((student, index) => (
                <Typography
                  key={index}
                  sx={{
                    color: "#3182CE",
                    fontWeight: "500",
                    cursor: "pointer",
                    "&:hover": { textDecoration: "underline" },
                  }}
                  onClick={() =>
                    navigate("/student-detailed-analysis", {
                      state: {
                        learnerId: student.learnerId,
                        learnerName: student.name,
                        schoolId,
                        grade,
                      },
                    })
                  }
                >
                  {student.name}
                  {student.stream && ` (${student.stream})`}: {student.score}%
                </Typography>
              ))}
            </Box>
          ))}
        </Paper>

        {/* Detailed Results */}
        <Paper
          sx={{ p: 3, mb: 3, bgcolor: "#fff", border: "1px solid #E2E8F0" }}
        >
          <Typography
            variant="h5"
            sx={{ fontWeight: "600", color: "#2D3748", mb: 2 }}
          >
            Detailed Results
          </Typography>

          <TableContainer>
            <Table>
              <TableHead>
                <TableRow sx={{ bgcolor: "#3182CE" }}>
                  <TableCell
                    sx={{ color: "#fff", fontWeight: "600", width: 50 }}
                  >
                    No.
                  </TableCell>
                  <TableCell sx={{ color: "#fff", fontWeight: "600" }}>
                    Student
                  </TableCell>
                  {displaySubjects.map((subject) => (
                    <TableCell
                      key={subject}
                      sx={{ color: "#fff", fontWeight: "600" }}
                    >
                      {getShortSubjectName(subject)}
                    </TableCell>
                  ))}
                  <TableCell sx={{ color: "#fff", fontWeight: "600" }}>
                    Total
                  </TableCell>
                  <TableCell
                    sx={{ color: "#fff", fontWeight: "600", width: 60 }}
                  >
                    Pos
                  </TableCell>

                  {/* Previous Position Headers */}
                  {selectedPreviousExams.map((exam, index) => {
                    const displayName = getExamDisplayTitle(
                      exam.examType,
                      exam.examName
                    );
                    return (
                      <TableCell
                        key={exam._id || index}
                        sx={{
                          color: "#fff",
                          fontWeight: "600",
                          textAlign: "center",
                          minWidth: 80,
                        }}
                      >
                        {displayName}
                      </TableCell>
                    );
                  })}

                  <TableCell sx={{ color: "#fff", fontWeight: "600" }}>
                    Stream
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {learnersByStream["General"].map((learner, index) => (
                  <TableRow key={learner.learnerId}>
                    <TableCell sx={{ fontWeight: "600" }}>
                      {index + 1}
                    </TableCell>
                    <TableCell>
                      <Typography
                        sx={{
                          cursor: "pointer",
                          "&:hover": { textDecoration: "underline" },
                        }}
                        onClick={() =>
                          navigate("/student-detailed-analysis", {
                            state: {
                              learnerId: learner.learnerId,
                              learnerName: learner.learnerName,
                              schoolId,
                              grade,
                            },
                          })
                        }
                      >
                        {learner.learnerName}
                        {learner.stream && ` (${learner.stream})`}
                      </Typography>
                    </TableCell>
                    {subjects.map((subject) => (
                      <TableCell key={subject}>
                        {learner.marks[subject] || "-"}
                      </TableCell>
                    ))}
                    <TableCell sx={{ fontWeight: "600" }}>
                      {learner.total}
                    </TableCell>
                    <TableCell>{learner.position}</TableCell>

                    {/* Previous Position Cells */}
                    {selectedPreviousExams.map((exam, idx) => {
                      const examKey = `${exam.term}-${exam.examType}-${
                        exam.examName || ""
                      }`;
                      const position = learner.previousPositions[examKey];
                      return (
                        <TableCell
                          key={exam._id || idx}
                          sx={{ textAlign: "center" }}
                        >
                          {position || (position === 0 ? "0" : "-")}
                        </TableCell>
                      );
                    })}

                    <TableCell>{learner.stream || "No Stream"}</TableCell>
                  </TableRow>
                ))}

                {/* Mean Row */}
                <TableRow sx={{ bgcolor: "#F0F9FF" }}>
                  <TableCell sx={{ fontWeight: "600" }}>-</TableCell>
                  <TableCell sx={{ fontWeight: "600" }}>Mean</TableCell>
                  {displaySubjects.map((subject) => (
                    <TableCell key={subject} sx={{ fontWeight: "600" }}>
                      {subjectAverages.find((s) => s.subject === subject)
                        ?.average || 0}
                    </TableCell>
                  ))}
                  <TableCell sx={{ fontWeight: "700", color: "#3182CE" }}>
                    {Number(
                      (
                        processedLearners.reduce(
                          (sum, learner) => sum + learner.total,
                          0
                        ) / (processedLearners.length || 1)
                      ).toFixed(2)
                    )}
                  </TableCell>
                  <TableCell sx={{ fontWeight: "600" }}>-</TableCell>
                  {/* Empty cells for previous positions in mean row */}
                  {selectedPreviousExams.map((_, idx) => (
                    <TableCell key={idx} sx={{ fontWeight: "600" }}>
                      -
                    </TableCell>
                  ))}
                  <TableCell sx={{ fontWeight: "600" }}>-</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>

          <Box sx={{ mt: 2, display: "flex", alignItems: "center", gap: 2 }}>
            <Button
              variant="contained"
              sx={{ bgcolor: "#3182CE" }}
              onClick={() => createDocument("General", "general", "pdf")}
              disabled={isGenerating.general}
            >
              {isGenerating.general ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                "Download General Results (PDF)"
              )}
            </Button>
            <Button
              variant="outlined"
              onClick={() => createDocument("General", "general", "docx")}
              disabled={isGenerating.general}
            >
              {isGenerating.general ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                "Download (DOCX)"
              )}
            </Button>
            <Button
              variant="outlined"
              onClick={() => createDocument("General", "general", "csv")}
              disabled={isGenerating.general}
            >
              {isGenerating.general ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                "Download (CSV)"
              )}
            </Button>
            <FormControlLabel
              control={
                <Checkbox
                  checked={includeHeader}
                  onChange={(e) => setIncludeHeader(e.target.checked)}
                />
              }
              label="Include header on every page"
            />
          </Box>

          {/* Stream-specific tables */}
          {streams.sort().map((stream) => (
            <Box key={stream} sx={{ mt: 3 }}>
              <Typography sx={{ fontWeight: "600", color: "#2D3748", mb: 1 }}>
                Stream: {stream}
              </Typography>
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow sx={{ bgcolor: "#3182CE" }}>
                      <TableCell
                        sx={{ color: "#fff", fontWeight: "600", width: 50 }}
                      >
                        No.
                      </TableCell>
                      <TableCell sx={{ color: "#fff", fontWeight: "600" }}>
                        Student
                      </TableCell>
                      {displaySubjects.map((subject) => (
                        <TableCell
                          key={subject}
                          sx={{ color: "#fff", fontWeight: "600" }}
                        >
                          {getShortSubjectName(subject)}
                        </TableCell>
                      ))}
                      <TableCell sx={{ color: "#fff", fontWeight: "600" }}>
                        Total
                      </TableCell>
                      <TableCell
                        sx={{ color: "#fff", fontWeight: "600", width: 60 }}
                      >
                        Pos
                      </TableCell>
                      {selectedPreviousExams.map((exam, index) => {
                        const displayName = getExamDisplayTitle(
                          exam.examType,
                          exam.examName
                        );
                        return (
                          <TableCell
                            key={exam._id || index}
                            sx={{
                              color: "#fff",
                              fontWeight: "600",
                              textAlign: "center",
                            }}
                          >
                            {displayName}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {learnersByStream[stream].map((learner, index) => (
                      <TableRow key={learner.learnerId}>
                        <TableCell sx={{ fontWeight: "600" }}>
                          {index + 1}
                        </TableCell>
                        <TableCell>
                          <Typography
                            sx={{
                              cursor: "pointer",
                              "&:hover": { textDecoration: "underline" },
                            }}
                            onClick={() =>
                              navigate("/student-detailed-analysis", {
                                state: {
                                  learnerId: learner.learnerId,
                                  learnerName: learner.learnerName,
                                  schoolId,
                                  grade,
                                },
                              })
                            }
                          >
                            {String(learner.learnerName || "N/A")}
                          </Typography>
                        </TableCell>
                        {subjects.map((subject) => (
                          <TableCell key={subject}>
                            {String(learner.marks[subject] ?? "-")}
                          </TableCell>
                        ))}
                        <TableCell sx={{ fontWeight: "600" }}>
                          {String(learner.total ?? "-")}
                        </TableCell>
                        <TableCell>{learner.position || "-"}</TableCell>
                        {selectedPreviousExams.map((exam, idx) => {
                          const examKey = `${exam.term}-${exam.examType}-${
                            exam.examName || ""
                          }`;
                          const position = learner.previousPositions[examKey];
                          return (
                            <TableCell
                              key={exam._id || idx}
                              sx={{ textAlign: "center" }}
                            >
                              {position || (position === 0 ? "0" : "-")}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    ))}
                    <TableRow sx={{ bgcolor: "#F0F9FF" }}>
                      <TableCell sx={{ fontWeight: "600" }}>-</TableCell>
                      <TableCell sx={{ fontWeight: "600" }}>Mean</TableCell>
                      {displaySubjects.map((subject) => (
                        <TableCell key={subject} sx={{ fontWeight: "600" }}>
                          {subjectAveragesByStream[stream].find(
                            (s) => s.subject === subject
                          )?.average || 0}
                        </TableCell>
                      ))}
                      <TableCell sx={{ fontWeight: "700", color: "#3182CE" }}>
                        {Number(
                          (
                            learnersByStream[stream].reduce(
                              (sum, learner) => sum + (learner.total || 0),
                              0
                            ) / (learnersByStream[stream].length || 1)
                          ).toFixed(2)
                        ) || 0}
                      </TableCell>
                      <TableCell sx={{ fontWeight: "600" }}>-</TableCell>
                      {selectedPreviousExams.map((_, idx) => (
                        <TableCell key={idx} sx={{ fontWeight: "600" }}>
                          -
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
              <Box
                sx={{ mt: 2, display: "flex", alignItems: "center", gap: 2 }}
              >
                <Button
                  variant="contained"
                  sx={{ bgcolor: "#3182CE" }}
                  onClick={() => createDocument(stream, "stream", "pdf")}
                  disabled={isGenerating.streams[stream]}
                >
                  {isGenerating.streams[stream] ? (
                    <CircularProgress size={24} color="inherit" />
                  ) : (
                    "Download Stream Report (PDF)"
                  )}
                </Button>
                <Button
                  variant="outlined"
                  onClick={() => createDocument(stream, "stream", "docx")}
                  disabled={isGenerating.streams[stream]}
                >
                  {isGenerating.streams[stream] ? (
                    <CircularProgress size={24} color="inherit" />
                  ) : (
                    "Download (DOCX)"
                  )}
                </Button>
                <Button
                  variant="outlined"
                  onClick={() => createDocument(stream, "stream", "csv")}
                  disabled={isGenerating.streams[stream]}
                >
                  {isGenerating.streams[stream] ? (
                    <CircularProgress size={24} color="inherit" />
                  ) : (
                    "Download (CSV)"
                  )}
                </Button>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={includeHeader}
                      onChange={(e) => setIncludeHeader(e.target.checked)}
                    />
                  }
                  label="Include header on every page"
                />
              </Box>
            </Box>
          ))}
        </Paper>

        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Button
            variant="contained"
            sx={{ bgcolor: "#3182CE" }}
            onClick={() => createFullPDF("pdf")}
            disabled={isGenerating.general}
          >
            {isGenerating.general ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              "Download Full Report (PDF)"
            )}
          </Button>
          <Button
            variant="outlined"
            onClick={() => createFullPDF("docx")}
            disabled={isGenerating.general}
          >
            {isGenerating.general ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              "Download Full Report (DOCX)"
            )}
          </Button>
          <Button
            variant="outlined"
            onClick={() => createFullPDF("csv")}
            disabled={isGenerating.general}
          >
            {isGenerating.general ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              "Download Full Report (CSV)"
            )}
          </Button>
          <FormControlLabel
            control={
              <Checkbox
                checked={includeHeader}
                onChange={(e) => setIncludeHeader(e.target.checked)}
              />
            }
            label="Include header on every page"
          />
        </Box>
        <ExamSelectionModal
          open={examSelectionOpen}
          onClose={() => setExamSelectionOpen(false)}
          onConfirm={handleExamSelectionConfirm}
          schoolId={schoolId}
          grade={grade}
          currentExam={{
            term,
            examType,
            examName: examName || null,
          }}
        />
      </motion.div>
    </Container>
  );
};

export default PerformanceAnalysis;